/**
 * All Countries
 */
const _ALL_COUNTRIES = [
  { "id": "AF", "text": "Afghanistan" },
  { "id": "AX", "text": "Åland Islands" },
  { "id": "AL", "text": "Albania" },
  { "id": "DZ", "text": "Algeria" },
  { "id": "AS", "text": "American Samoa" },
  { "id": "AD", "text": "Andorra" },
  { "id": "AO", "text": "Angola" },
  { "id": "AI", "text": "Anguilla" },
  { "id": "AQ", "text": "Antarctica" },
  { "id": "AG", "text": "Antigua and Barbuda" },
  { "id": "AR", "text": "Argentina" },
  { "id": "AM", "text": "Armenia" },
  { "id": "AW", "text": "Aruba" },
  { "id": "AU", "text": "Australia" },
  { "id": "AT", "text": "Austria" },
  { "id": "AZ", "text": "Azerbaijan" },
  { "id": "BS", "text": "Bahamas" },
  { "id": "BH", "text": "Bahrain" },
  { "id": "BD", "text": "Bangladesh" },
  { "id": "BB", "text": "Barbados" },
  { "id": "BY", "text": "Belarus" },
  { "id": "BE", "text": "Belgium" },
  { "id": "BZ", "text": "Belize" },
  { "id": "BJ", "text": "Benin" },
  { "id": "BM", "text": "Bermuda" },
  { "id": "BT", "text": "Bhutan" },
  { "id": "BO", "text": "Bolivia (Plurinational State of)" },
  { "id": "BQ", "text": "Bonaire, Sint Eustatius and Saba" },
  { "id": "BA", "text": "Bosnia and Herzegovina" },
  { "id": "BW", "text": "Botswana" },
  { "id": "BV", "text": "Bouvet Island" },
  { "id": "BR", "text": "Brazil" },
  { "id": "IO", "text": "British Indian Ocean Territory" },
  { "id": "BN", "text": "Brunei Darussalam" },
  { "id": "BG", "text": "Bulgaria" },
  { "id": "BF", "text": "Burkina Faso" },
  { "id": "BI", "text": "Burundi" },
  { "id": "KH", "text": "Cambodia" },
  { "id": "CM", "text": "Cameroon" },
  { "id": "CA", "text": "Canada" },
  { "id": "CV", "text": "Cabo Verde" },
  { "id": "KY", "text": "Cayman Islands" },
  { "id": "CF", "text": "Central African Republic" },
  { "id": "TD", "text": "Chad" },
  { "id": "CL", "text": "Chile" },
  { "id": "CN", "text": "China" },
  { "id": "CX", "text": "Christmas Island" },
  { "id": "CC", "text": "Cocos (Keeling) Islands" },
  { "id": "CO", "text": "Colombia" },
  { "id": "KM", "text": "Comoros" },
  { "id": "CG", "text": "Congo" },
  { "id": "CD", "text": "Congo (Democratic Republic of the)" },
  { "id": "CK", "text": "Cook Islands" },
  { "id": "CR", "text": "Costa Rica" },
  { "id": "CI", "text": "Côte d'Ivoire" },
  { "id": "HR", "text": "Croatia" },
  { "id": "CU", "text": "Cuba" },
  { "id": "CW", "text": "Curaçao" },
  { "id": "CY", "text": "Cyprus" },
  { "id": "CZ", "text": "Czech Republic" },
  { "id": "DK", "text": "Denmark" },
  { "id": "DJ", "text": "Djibouti" },
  { "id": "DM", "text": "Dominica" },
  { "id": "DO", "text": "Dominican Republic" },
  { "id": "EC", "text": "Ecuador" },
  { "id": "EG", "text": "Egypt" },
  { "id": "SV", "text": "El Salvador" },
  { "id": "GQ", "text": "Equatorial Guinea" },
  { "id": "ER", "text": "Eritrea" },
  { "id": "EE", "text": "Estonia" },
  { "id": "ET", "text": "Ethiopia" },
  { "id": "FK", "text": "Falkland Islands (Malvinas)" },
  { "id": "FO", "text": "Faroe Islands" },
  { "id": "FJ", "text": "Fiji" },
  { "id": "FI", "text": "Finland" },
  { "id": "FR", "text": "France" },
  { "id": "GF", "text": "French Guiana" },
  { "id": "PF", "text": "French Polynesia" },
  { "id": "TF", "text": "French Southern Territories" },
  { "id": "GA", "text": "Gabon" },
  { "id": "GM", "text": "Gambia" },
  { "id": "GE", "text": "Georgia" },
  { "id": "DE", "text": "Germany" },
  { "id": "GH", "text": "Ghana" },
  { "id": "GI", "text": "Gibraltar" },
  { "id": "GR", "text": "Greece" },
  { "id": "GL", "text": "Greenland" },
  { "id": "GD", "text": "Grenada" },
  { "id": "GP", "text": "Guadeloupe" },
  { "id": "GU", "text": "Guam" },
  { "id": "GT", "text": "Guatemala" },
  { "id": "GG", "text": "Guernsey" },
  { "id": "GN", "text": "Guinea" },
  { "id": "GW", "text": "Guinea-Bissau" },
  { "id": "GY", "text": "Guyana" },
  { "id": "HT", "text": "Haiti" },
  { "id": "HM", "text": "Heard Island and McDonald Islands" },
  { "id": "VA", "text": "Holy See" },
  { "id": "HN", "text": "Honduras" },
  { "id": "HK", "text": "Hong Kong" },
  { "id": "HU", "text": "Hungary" },
  { "id": "IS", "text": "Iceland" },
  { "id": "IN", "text": "India" },
  { "id": "ID", "text": "Indonesia" },
  { "id": "IR", "text": "Iran (Islamic Republic of)" },
  { "id": "IQ", "text": "Iraq" },
  { "id": "IE", "text": "Ireland" },
  { "id": "IM", "text": "Isle of Man" },
  { "id": "IL", "text": "Israel" },
  { "id": "IT", "text": "Italy" },
  { "id": "JM", "text": "Jamaica" },
  { "id": "JP", "text": "Japan" },
  { "id": "JE", "text": "Jersey" },
  { "id": "JO", "text": "Jordan" },
  { "id": "KZ", "text": "Kazakhstan" },
  { "id": "KE", "text": "Kenya" },
  { "id": "KI", "text": "Kiribati" },
  { "id": "KP", "text": "Korea (Democratic People's Republic of)" },
  { "id": "KR", "text": "Korea (Republic of)" },
  { "id": "KW", "text": "Kuwait" },
  { "id": "KG", "text": "Kyrgyzstan" },
  { "id": "LA", "text": "Lao People's Democratic Republic" },
  { "id": "LV", "text": "Latvia" },
  { "id": "LB", "text": "Lebanon" },
  { "id": "LS", "text": "Lesotho" },
  { "id": "LR", "text": "Liberia" },
  { "id": "LY", "text": "Libya" },
  { "id": "LI", "text": "Liechtenstein" },
  { "id": "LT", "text": "Lithuania" },
  { "id": "LU", "text": "Luxembourg" },
  { "id": "MO", "text": "Macao" },
  { "id": "MK", "text": "Macedonia (the former Yugoslav Republic of)" },
  { "id": "MG", "text": "Madagascar" },
  { "id": "MW", "text": "Malawi" },
  { "id": "MY", "text": "Malaysia" },
  { "id": "MV", "text": "Maldives" },
  { "id": "ML", "text": "Mali" },
  { "id": "MT", "text": "Malta" },
  { "id": "MH", "text": "Marshall Islands" },
  { "id": "MQ", "text": "Martinique" },
  { "id": "MR", "text": "Mauritania" },
  { "id": "MU", "text": "Mauritius" },
  { "id": "YT", "text": "Mayotte" },
  { "id": "MX", "text": "Mexico" },
  { "id": "FM", "text": "Micronesia (Federated States of)" },
  { "id": "MD", "text": "Moldova (Republic of)" },
  { "id": "MC", "text": "Monaco" },
  { "id": "MN", "text": "Mongolia" },
  { "id": "ME", "text": "Montenegro" },
  { "id": "MS", "text": "Montserrat" },
  { "id": "MA", "text": "Morocco" },
  { "id": "MZ", "text": "Mozambique" },
  { "id": "MM", "text": "Myanmar" },
  { "id": "NA", "text": "Namibia" },
  { "id": "NR", "text": "Nauru" },
  { "id": "NP", "text": "Nepal" },
  { "id": "NL", "text": "Netherlands" },
  { "id": "NC", "text": "New Caledonia" },
  { "id": "NZ", "text": "New Zealand" },
  { "id": "NI", "text": "Nicaragua" },
  { "id": "NE", "text": "Niger" },
  { "id": "NG", "text": "Nigeria" },
  { "id": "NU", "text": "Niue" },
  { "id": "NF", "text": "Norfolk Island" },
  { "id": "MP", "text": "Northern Mariana Islands" },
  { "id": "NO", "text": "Norway" },
  { "id": "OM", "text": "Oman" },
  { "id": "PK", "text": "Pakistan" },
  { "id": "PW", "text": "Palau" },
  { "id": "PS", "text": "Palestine, State of" },
  { "id": "PA", "text": "Panama" },
  { "id": "PG", "text": "Papua New Guinea" },
  { "id": "PY", "text": "Paraguay" },
  { "id": "PE", "text": "Peru" },
  { "id": "PH", "text": "Philippines" },
  { "id": "PN", "text": "Pitcairn" },
  { "id": "PL", "text": "Poland" },
  { "id": "PT", "text": "Portugal" },
  { "id": "PR", "text": "Puerto Rico" },
  { "id": "QA", "text": "Qatar" },
  { "id": "RE", "text": "Réunion" },
  { "id": "RO", "text": "Romania" },
  { "id": "RU", "text": "Russian Federation" },
  { "id": "RW", "text": "Rwanda" },
  { "id": "BL", "text": "Saint Barthélemy" },
  { "id": "SH", "text": "Saint Helena, Ascension and Tristan da Cunha" },
  { "id": "KN", "text": "Saint Kitts and Nevis" },
  { "id": "LC", "text": "Saint Lucia" },
  { "id": "MF", "text": "Saint Martin (French part)" },
  { "id": "PM", "text": "Saint Pierre and Miquelon" },
  { "id": "VC", "text": "Saint Vincent and the Grenadines" },
  { "id": "WS", "text": "Samoa" },
  { "id": "SM", "text": "San Marino" },
  { "id": "ST", "text": "Sao Tome and Principe" },
  { "id": "SA", "text": "Saudi Arabia" },
  { "id": "SN", "text": "Senegal" },
  { "id": "RS", "text": "Serbia" },
  { "id": "SC", "text": "Seychelles" },
  { "id": "SL", "text": "Sierra Leone" },
  { "id": "SG", "text": "Singapore" },
  { "id": "SX", "text": "Sint Maarten (Dutch part)" },
  { "id": "SK", "text": "Slovakia" },
  { "id": "SI", "text": "Slovenia" },
  { "id": "SB", "text": "Solomon Islands" },
  { "id": "SO", "text": "Somalia" },
  { "id": "ZA", "text": "South Africa" },
  { "id": "GS", "text": "South Georgia and the South Sandwich Islands" },
  { "id": "SS", "text": "South Sudan" },
  { "id": "ES", "text": "Spain" },
  { "id": "LK", "text": "Sri Lanka" },
  { "id": "SD", "text": "Sudan" },
  { "id": "SR", "text": "Suriname" },
  { "id": "SJ", "text": "Svalbard and Jan Mayen" },
  { "id": "SZ", "text": "Swaziland" },
  { "id": "SE", "text": "Sweden" },
  { "id": "CH", "text": "Switzerland" },
  { "id": "SY", "text": "Syrian Arab Republic" },
  { "id": "TW", "text": "Taiwan, Province of China" },
  { "id": "TJ", "text": "Tajikistan" },
  { "id": "TZ", "text": "Tanzania, United Republic of" },
  { "id": "TH", "text": "Thailand" },
  { "id": "TL", "text": "Timor-Leste" },
  { "id": "TG", "text": "Togo" },
  { "id": "TK", "text": "Tokelau" },
  { "id": "TO", "text": "Tonga" },
  { "id": "TT", "text": "Trinidad and Tobago" },
  { "id": "TN", "text": "Tunisia" },
  { "id": "TR", "text": "Turkey" },
  { "id": "TM", "text": "Turkmenistan" },
  { "id": "TC", "text": "Turks and Caicos Islands" },
  { "id": "TV", "text": "Tuvalu" },
  { "id": "UG", "text": "Uganda" },
  { "id": "UA", "text": "Ukraine" },
  { "id": "AE", "text": "United Arab Emirates" },
  { "id": "GB", "text": "United Kingdom of Great Britain and Northern Ireland" },
  { "id": "US", "text": "United States of America" },
  { "id": "UM", "text": "United States Minor Outlying Islands" },
  { "id": "UY", "text": "Uruguay" },
  { "id": "UZ", "text": "Uzbekistan" },
  { "id": "VU", "text": "Vanuatu" },
  { "id": "VE", "text": "Venezuela (Bolivarian Republic of)" },
  { "id": "VN", "text": "Viet Nam" },
  { "id": "VG", "text": "Virgin Islands (British)" },
  { "id": "VI", "text": "Virgin Islands (U.S.)" },
  { "id": "WF", "text": "Wallis and Futuna" },
  { "id": "EH", "text": "Western Sahara" },
  { "id": "YE", "text": "Yemen" },
  { "id": "ZM", "text": "Zambia" },
  { "id": "ZW", "text": "Zimbabwe" }
];

/**
 * US States
 */
const _US_STATES = [
  { "id": "AL", "text": "Alabama" },
  { "id": "AK", "text": "Alaska" },
  { "id": "AZ", "text": "Arizona" },
  { "id": "AR", "text": "Arkansas" },
  { "id": "CA", "text": "California" },
  { "id": "CO", "text": "Colorado" },
  { "id": "CT", "text": "Connecticut" },
  { "id": "DE", "text": "Delaware" },
  { "id": "FL", "text": "Florida" },
  { "id": "GA", "text": "Georgia" },
  { "id": "HI", "text": "Hawaii" },
  { "id": "ID", "text": "Idaho" },
  { "id": "IL", "text": "Illinois" },
  { "id": "IN", "text": "Indiana" },
  { "id": "IA", "text": "Iowa" },
  { "id": "KS", "text": "Kansas" },
  { "id": "KY", "text": "Kentucky" },
  { "id": "LA", "text": "Louisiana" },
  { "id": "ME", "text": "Maine" },
  { "id": "MD", "text": "Maryland" },
  { "id": "MA", "text": "Massachusetts" },
  { "id": "MI", "text": "Michigan" },
  { "id": "MN", "text": "Minnesota" },
  { "id": "MS", "text": "Mississippi" },
  { "id": "MO", "text": "Missouri" },
  { "id": "MT", "text": "Montana" },
  { "id": "NE", "text": "Nebraska" },
  { "id": "NV", "text": "Nevada" },
  { "id": "NH", "text": "New Hampshire" },
  { "id": "NJ", "text": "New Jersey" },
  { "id": "NM", "text": "New Mexico" },
  { "id": "NY", "text": "New York" },
  { "id": "NC", "text": "North Carolina" },
  { "id": "ND", "text": "North Dakota" },
  { "id": "OH", "text": "Ohio" },
  { "id": "OK", "text": "Oklahoma" },
  { "id": "OR", "text": "Oregon" },
  { "id": "PA", "text": "Pennsylvania" },
  { "id": "RI", "text": "Rhode Island" },
  { "id": "SC", "text": "South Carolina" },
  { "id": "SD", "text": "South Dakota" },
  { "id": "TN", "text": "Tennessee" },
  { "id": "TX", "text": "Texas" },
  { "id": "UT", "text": "Utah" },
  { "id": "VT", "text": "Vermont" },
  { "id": "VA", "text": "Virginia" },
  { "id": "WA", "text": "Washington" },
  { "id": "WV", "text": "West Virginia" },
  { "id": "WI", "text": "Wisconsin" },
  { "id": "WY", "text": "Wyoming" }
];

/**
 * The five New York City boroughs, used for the .NYC nexus requirement.
 *
 * `id` is the value stored in postalInfo.addr.city. `aliases` are alternative
 * spellings we still accept when the contact was populated from an existing
 * address rather than picked from the borough dropdown.
 */
const _NYC_BOROUGHS = [
  { "id": "Bronx",         "text": "The Bronx",     "aliases": ["the bronx"] },
  { "id": "Brooklyn",      "text": "Brooklyn",      "aliases": ["kings"] },
  { "id": "Manhattan",     "text": "Manhattan",     "aliases": ["new york", "new york city", "nyc"] },
  { "id": "Queens",        "text": "Queens",        "aliases": [] },
  { "id": "Staten Island", "text": "Staten Island", "aliases": ["richmond"] }
];

/**
 * Is the supplied city one of the five .NYC eligible boroughs?
 */
function _isNycBorough(city) {
    const v = (city || "").trim().toLowerCase();
    if (!v) {
        return false;
    }
    return !!_NYC_BOROUGHS.find(function(b) {
        return b.id.toLowerCase() === v
            || b.text.toLowerCase() === v
            || b.aliases.includes(v);
    });
}

/**
 * .NYC forbids P.O. Box registrant addresses, so reject any address line
 * that looks like one.
 */
function _isPoBoxAddress(street) {
    const lines = Array.isArray(street) ? street : [street];
    return lines.some(function(line) {
        const v = (line || "").trim();
        return /\bp\.?\s*o\.?\s*box\b/i.test(v) || /\bpost(al)?\s+office\s+box\b/i.test(v);
    });
}

/**
 * All EU Nationalities
 */
const _EU_NATIONALITIES = [
    {
        text: "Austrian",
        id: "AT"
    },
    {
        text: "Belgian",
        id: "BE"
    },
    {
        text: "Bulgarian",
        id: "BG"
    },
    {
        text: "Swiss",
        id: "CH"
    },
    {
        text: "Cypriot",
        id: "CY"
    },
    {
        text: "Czech",
        id: "CZ"
    },
    {
        text: "German",
        id: "DE"
    },
    {
        text: "Danish",
        id: "DK"
    },
    {
        text: "Estonian",
        id: "EE"
    },
    {
        text: "Spanish",
        id: "ES"
    },
    {
        text: "Finnish",
        id: "FI"
    },
    {
        text: "French",
        id: "FR"
    },
    {
        text: "Greek",
        id: "GR"
    },
    {
        text: "Croatian",
        id: "HR"
    },
    {
        text: "Hungarian",
        id: "HU"
    },
    {
        text: "Irish",
        id: "IE"
    },
    {
        text: "Icelandic",
        id: "IS"
    },
    {
        text: "Italian",
        id: "IT"
    },
    {
        text: "Liechtensteiner",
        id: "LI"
    },
    {
        text: "Lithuanian",
        id: "LT"
    },
    {
        text: "Luxembourgish",
        id: "LU"
    },
    {
        text: "Latvian",
        id: "LV"
    },
    {
        text: "Maltese",
        id: "MT"
    },
    {
        text: "Dutch",
        id: "NL"
    },
    {
        text: "Norwegian",
        id: "NO"
    },
    {
        text: "Polish",
        id: "PL"
    },
    {
        text: "Portuguese",
        id: "PT"
    },
    {
        text: "Romanian",
        id: "RO"
    },
    {
        text: "Swedish",
        id: "SE"
    },
    {
        text: "Slovenian",
        id: "SI"
    },
    {
        text: "Slovak",
        id: "SK"
    },
    {
        text: "Sammarinese",
        id: "SM"
    },
    {
        text: "Vatican",
        id: "VA"
    }
];

const _EEA_COUNTRIES = [
    "AT","BE","BG","CY","CZ","DE","DK","EE","ES","FI","FR","GR",
    "HR","HU","IE","IS","IT","LI","LT","LU","LV","MT","NL","NO",
    "PL","PT","RO","SE","SI","SK",
];

/**
 * All known domain contact requirements.
 */
const _DOMAIN_CONTACT_REQUIREMENTS = {
  ".aero": {
      roles: ["registrant"],
      dacMessage: translation.get("contact_validated_aero_dacMessage"),
      dacLink: "https://www.information.aero/node/add/request-aero-id",
      dacLinkText: translation.get("contact_validated_aero_dacLinkText"),
      affinity: ["aero_ens_id","aero_ens_password"],
      extraValidation: {
          "aero_ens_id": {
              invalidHtml(c) {
                  return translation.get("contact_validated_aero_id_required");
              },
              validation(c) {
                  return c.extension.aero_ens_id && c.extension.aero_ens_id.length > 0;
              },
              "extension": true
          },
          "aero_ens_password": {
              invalidHtml(c) {
                  return translation.get("contact_validated_aero_password_required");
              },
              validation(c) {
                  return c.extension.aero_ens_password && c.extension.aero_ens_password.length > 0;
              },
              "extension": true
          }
      },
  },
  ".au": {
    roles: ["registrant"],
    dacMessage: translation.get("contact_validated_au_dacMessage"),

    affinity: ["type"],

    extraValidation: {
      cc: {
        invalidHtml(c) { return translation.get("contact_validated_au_cc_required"); },
        validation(c) { return c?.postalInfo?.addr?.cc === "AU"; },
        extension: true
      },

      type: {
        invalidHtml(c) { return translation.get("contact_validated_au_type_required"); },
        getOptions(c) {
          return _DOMAIN_CONTACT_REQUIREMENTS[".au"].typeOptions || [];
        },
        validation(c) {
          const v = c?.extension?.type;
          const opts =
            (_DOMAIN_CONTACT_REQUIREMENTS[".au"].typeOptions ||
             _DOMAIN_CONTACT_REQUIREMENTS[".au"]["extraValidation"]["type"].getOptions(c) ||
             []);
          return !!opts.find(o => o.id === v);
        },
        extension: true
      },

      eligibility_name: {
        invalidHtml(c) { return translation.get("contact_validated_au_eligibility_name_required"); },
        validation(c) {
          const v = c?.extension?.eligibility_name;
          return typeof v === "string" && v.trim().length > 0;
        },
        extension: true
      },

      eligibility_id_type: {
        invalidHtml(c) { return translation.get("contact_validated_au_eligibility_id_type_required"); },

        getOptions(c) {
          const typeText = c?.extension?.type; // <-- TEXT VERSION now
          if (!typeText || typeText === "Citizen/Resident") return [];

          // Allowed Eligibility ID Type values depend on eligibility type (TEXT KEYS now)
          const allowedByTypeText = {
            "Trade Union": ["OTHER"],
            "Company": ["ACN", "ABN"],
            "Trademark Owner": ["TM"],
            "Pending TM Owner": ["TM"],

            // Common org-like cases
            "Charity": ["ABN"],
            "Club": ["ABN"],
            "Incorporated Association": ["ABN"],
            "Non-profit Organisation": ["ABN"],
            "Sole Trader": ["ABN"],
            "Partnership": ["ABN"],

            // Remaining org-like types -> ABN default
            "Charitable Trust": ["ABN"],
            "Commonwealth entity": ["ABN"],
            "Company Limited by Guarantee": ["ABN"],
            "Foreign Embassy or Consulate": ["ABN"],
            "Government Body": ["ABN"],
            "Indigenous Corporation": ["ABN"],
            "Non-distributing Cooperative": ["ABN"],
            "Non-trading Cooperative": ["ABN"],
            "Political Party": ["ABN"],
            "Public/Private Ancillary Fund": ["ABN"],
            "Registered Business": ["ABN"],
            "Registered Organisation": ["ABN"],
            "Statutory Body": ["ABN"],
            "Trading Cooperative": ["ABN"],
            "Trust": ["ABN"]
          };

          const values = allowedByTypeText[typeText] || ["ABN"];
          return values.map(id => ({ id, text: id }));
        },

        validation(c) {
          const typeText = c?.extension?.type; // <-- TEXT VERSION now
          if (!typeText || typeText === "Citizen/Resident") return true;

          const v = c?.extension?.eligibility_id_type;
          if (typeof v !== "string" || v.trim().length === 0) return false;

          const opts =
            (_DOMAIN_CONTACT_REQUIREMENTS[".au"]["extraValidation"]["eligibility_id_type"].getOptions(c) || []);
          return opts.some(o => o.id === v);
        },
        extension: true
      },

      eligibility_id: {
        invalidHtml(c) { return translation.get("contact_validated_au_eligibility_id_required"); },
        validation(c) {
          const typeText = c?.extension?.type;
          if (!typeText || typeText === "Citizen/Resident") return true;

          const v = c?.extension?.eligibility_id;
          return typeof v === "string" && v.trim().length > 0;
        },
        extension: true
      },

      policy_reason: {
        invalidHtml(c) { return translation.get("contact_validated_au_policy_reason_required"); },

        getOptions(c) {
          const typeText = c?.extension?.type;
          if (!typeText || typeText === "Citizen/Resident") return [];

          return [
            { id: "1", text: "1 — Exact match to acronym/abbreviation or trademark" },
            { id: "2", text: "2 — Closely and substantially connected to the registrant (default)" }
          ];
        },

        validation(c) {
          const typeText = c?.extension?.type;
          if (!typeText || typeText === "Citizen/Resident") return true;

          const v = c?.extension?.policy_reason;
          const opts =
            (_DOMAIN_CONTACT_REQUIREMENTS[".au"]["extraValidation"]["policy_reason"].getOptions(c) || []);
          return opts.some(o => o.id === String(v));
        },
        extension: true
      },

      registrant_id_type: {
        invalidHtml(c) { return translation.get("contact_validated_au_registrant_id_type_required"); },

        getOptions(c) {
          const typeText = c?.extension?.type;
          if (!typeText || typeText === "Citizen/Resident") return [];

          return [
            { id: "ABN", text: "ABN — Australian Business Number" },
            { id: "ACN", text: "ACN — Australian Company Number" }
          ];
        },

        validation(c) {
          const typeText = c?.extension?.type;
          if (!typeText || typeText === "Citizen/Resident") return true;

          const v = c?.extension?.registrant_id_type;
          const opts =
            (_DOMAIN_CONTACT_REQUIREMENTS[".au"]["extraValidation"]["registrant_id_type"].getOptions(c) || []);
          return opts.some(o => o.id === v);
        },
        extension: true
      },

      registrant_id: {
        invalidHtml(c) { return translation.get("contact_validated_au_registrant_id_required"); },
        validation(c) {
          const typeText = c?.extension?.type;
          if (!typeText || typeText === "Citizen/Resident") return true;

          const v = c?.extension?.registrant_id;
          return typeof v === "string" && v.trim().length > 0;
        },
        extension: true
      },

      priority_contact_id: {
        invalidHtml(c) { return translation.get("contact_validated_au_priority_contact_id_required"); },
        validation(c) {
          const v = c?.extension?.priority_contact_id;
          return (v === undefined || v === null || v === "")
            ? true
            : (typeof v === "string" && v.trim().length > 0);
        },
        extension: true
      },

      priority_auth_info: {
        invalidHtml(c) { return translation.get("contact_validated_au_priority_auth_info_required"); },
        validation(c) {
          const v = c?.extension?.priority_auth_info;
          return (v === undefined || v === null || v === "")
            ? true
            : (typeof v === "string" && v.trim().length > 0);
        },
        extension: true
      },

      sp: {
        invalidHtml(c) { return translation.get("contact_validated_au_sp_required"); },
        validation(c) {
          if (c.postalInfo.addr.cc !== "AU") return true;
          return !!_DOMAIN_CONTACT_REQUIREMENTS[".au"].states.find(function(s) { return s.code === c.postalInfo.addr.sp; });
        }
      },

      pc: {
        invalidHtml(c) { return translation.get("contact_validated_au_pc_invalid"); },
        validation(c) {
          var sp = c.postalInfo.addr.sp;
          var pc = c.postalInfo.addr.pc;
          if (!pc || !sp) return true;

          var digits = pc.replace(/\D/g, "");
          if (digits.length !== 4) return false;

          var n = parseInt(digits, 10);
          var ranges = {
            "NSW": [[1000,1999],[2000,2599],[2620,2899],[2921,2999]],
            "ACT": [[200,299],[2600,2618],[2900,2920]],
            "VIC": [[3000,3999],[8000,8999]],
            "QLD": [[4000,4999],[9000,9999]],
            "SA":  [[5000,5999]],
            "WA":  [[6000,6999]],
            "TAS": [[7000,7999]],
            "NT":  [[800,999]]
          };
          var stateRanges = ranges[sp];
          if (!stateRanges) return false;
          return !!stateRanges.filter(function(r) { return n >= r[0] && n <= r[1]; }).length;
        }
      }
    },

    // TEXT VALUES (not abbreviated IDs)
    typeOptions: [
      { id: "Citizen/Resident",               text: "Citizen/Resident",               affinity: [] },

      { id: "Company",                        text: "Company",                        affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Sole Trader",                    text: "Sole Trader",                    affinity: ["policy_reason","registrant_id_type","registrant_id"] },
      { id: "Charity",                        text: "Charity",                        affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Club",                           text: "Club",                           affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Incorporated Association",       text: "Incorporated Association",       affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Non-profit Organisation",        text: "Non-profit Organisation",        affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Trade Union",                    text: "Trade Union",                    affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Trademark Owner",                text: "Trademark Owner",                affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Pending TM Owner",               text: "Pending TM Owner",               affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Partnership",                    text: "Partnership",                    affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },

      { id: "Charitable Trust",               text: "Charitable Trust",               affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Commonwealth entity",            text: "Commonwealth entity",            affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Company Limited by Guarantee",   text: "Company Limited by Guarantee",   affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Foreign Embassy or Consulate",   text: "Foreign Embassy or Consulate",   affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Government Body",                text: "Government Body",                affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Indigenous Corporation",         text: "Indigenous Corporation",         affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Non-distributing Cooperative",   text: "Non-distributing Cooperative",   affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Non-trading Cooperative",        text: "Non-trading Cooperative",        affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Political Party",                text: "Political Party",                affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Public/Private Ancillary Fund",  text: "Public/Private Ancillary Fund",  affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Registered Business",            text: "Registered Business",            affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Registered Organisation",        text: "Registered Organisation",        affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Statutory Body",                 text: "Statutory Body",                 affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Trading Cooperative",            text: "Trading Cooperative",            affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Trust",                          text: "Trust",                          affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] }
    ],
    states: [
      { code: "ACT", name: "Australian Capital Territory" },
      { code: "NSW", name: "New South Wales" },
      { code: "NT",  name: "Northern Territory" },
      { code: "QLD", name: "Queensland" },
      { code: "SA",  name: "South Australia" },
      { code: "TAS", name: "Tasmania" },
      { code: "VIC", name: "Victoria" },
      { code: "WA",  name: "Western Australia" }
    ]
  },
  ".be": {
      roles: ["registrant"],
      defaultType: "individual",
      extraValidation: {
          "language": {
              invalidHtml(c) {
                  return translation.get("contact_validated_be_language_required");
              },
              validation(c) {
                  return !![
                      {
                          id: "de"
                      },
                      {
                          id: "fr"
                      },
                      {
                          id: "nl"
                      }
                  ].find(i=>i.id == c.extension['language']);
              },
              getOptions(c) {
                  return [
                      {
                          text: "Dutch",
                          id: "nl"
                      },
                      {
                          text: "German",
                          id: "de"
                      },
                      {
                          text: "French",
                          id: "fr"
                      }
                  ];
              },
              "extension": true
          },
      },
      typeOptions: [
          {
              id: "individual",
              text: "Individual",
              affinity: ["language"]
          },
          {
              id: "organization",
              text: "Organization",
              affinity: ["language"]
          }
      ]
  },
  ".ca": {
      dacMessage: translation.get("contact_validated_ca_dacMessage"),
      affinity: ["registry-agreement","type"],
      "requiredConfirmation": {
          id: "registry-agreement",
          text: translation.get("contact_validated_ca_requiredConfirmation_text"),
          "basketText": translation.get("contact_validated_ca_requiredConfirmation_basketText"),
      },
      moreInfoLink: "https://www.cira.ca/en/resources/documents/about/registrant-agreement/",
      moreInfoLinkPreText: translation.get("contact_validated_ca_moreInfoLinkPreText"),
      moreInfoLinkText: "click here",
      extraValidation: {
          "language": {
              invalidHtml(c) {
                  return translation.get("contact_validated_ca_valid_language_required");
              },
              validation(c) {
                  return !![
                      {
                          id: "en"
                      },
                      {
                          id: "fr"
                      }
                  ].find(i=>i.id == c.extension['language']);
              },
              getOptions(c) {
                  return [
                      {
                          text: "English",
                          id: "en"
                      },
                      {
                          text: "French",
                          id: "fr"
                      }
                  ];
              },
              "extension": true
          },
          "cc": {
              invalidHtml(c) {
                  return translation.get("contact_validated_ca_country_must_eq_canada");
              },
              validation(c) {
                  return c.postalInfo.addr.cc == "CA";
              },
          },
          "sp": {
              invalidHtml(c) {
                  return translation.get("contact_validated_ca_valid_province_required");
              },
              validation(c) {
                  return !!_DOMAIN_CONTACT_REQUIREMENTS[".ca"]['extraValidation']['sp'].options(c).find(o => o.id == c.postalInfo.addr.sp);
              },
              options(c) {
                  return [
                      {
                          text: "Alberta",
                          id: "AB"
                      },
                      {
                          text: "British Columbia",
                          id: "BC"
                      },
                      {
                          text: "Manitoba",
                          id: "MB"
                      },
                      {
                          text: "New Brunswick",
                          id: "NB"
                      },
                      {
                          text: "Newfoundland and Labrador",
                          id: "NL"
                      },
                      {
                          text: "Northwest Territories",
                          id: "NT"
                      },
                      {
                          text: "Nova Scotia",
                          id: "NS"
                      },
                      {
                          text: "Nunavut",
                          id: "NU"
                      },
                      {
                          text: "Ontario",
                          id: "ON"
                      },
                      {
                          text: "Prince Edward Island",
                          id: "PE"
                      },
                      {
                          text: "Quebec",
                          id: "QC"
                      },
                      {
                          text: "Saskatchewan",
                          id: "SK"
                      },
                      {
                          text: "Yukon",
                          id: "YK"
                      }
                  ];
              }
          },
          "type": {
              invalidHtml(c) {
                  return translation.get("contact_validated_ca_contact_type_required");
              },
              validation(c) {
                  if( c.extension && c.extension['type'] ){
                      return !!_DOMAIN_CONTACT_REQUIREMENTS[".ca"].typeOptions.find(o => o.id == c.extension['type'])
                  } else {
                      return false;
                  }
              },
              "extension": true
          }
      },
      "typeOptions": [
        // --- Sorted by common use cases ---
        {
            id: "CCO",
            text: "Corporation (Canada or Canadian province or territory)",
            affinity: ["org","language"]
        },
        {
            id: "CCT",
            text: "Canadian citizen",
            affinity: ["language"]
        },
        {
            id: "RES",
            text: "Permanent resident of Canada",
            affinity: ["language"]
        },
        {
            id: "PRT",
            text: "Partnership registered in Canada",
            affinity: ["org","language"]
        },
        {
            id: "ASS",
            text: "Canadian unincorporated association",
            affinity: ["org","language"]
        },
        {
            id: "TRS",
            text: "Trust established in Canada",
            affinity: ["org","language"]
        },
        {
            id: "EDU",
            text: "Canadian educational institution",
            affinity: ["org","language"]
        },
        {
            id: "GOV",
            text: "Government or government entity in Canada",
            affinity: ["org","language"]
        },
        {
            id: "LAM",
            text: "Canadian library, archive or museum",
            affinity: ["org","language"]
        },
        {
            id: "HOP",
            text: "Canadian hospital",
            affinity: ["org","language"]
        },
        {
            id: "TDM",
            text: "Trademark owner (registered in Canada)",
            affinity: ["org","language"]
        },
        {
            id: "OMK",
            text: "Official mark protected under the Trademarks Act (Canada)",
            affinity: ["org","language"]
        },
        {
            id: "TRD",
            text: "Canadian trade union",
            affinity: ["org","language"]
        },
        {
            id: "PLT",
            text: "Canadian political party",
            affinity: ["org","language"]
        },
        {
            id: "INB",
            text: "Indian Band recognized by the Indian Act of Canada",
            affinity: ["org","language"]
        },
        {
            id: "LGR",
            text: "Legal representative of a Canadian citizen or permanent resident",
            affinity: ["language"]
        },
        {
            id: "ABO",
            text: "Aboriginal peoples (individuals or groups) indigenous to Canada",
            affinity: ["language"]
        },
        {
            id: "MAJ",
            text: "His Majesty the King",
            affinity: ["org","language"]
        }
      ]

  },
  ".cl": {
    roles: ["registrant"],
    dacMessage: translation.get("contact_validated_cl_dacMessage"),

    affinity: ["type"],

    extraValidation: {
        type: {
            invalidHtml(c) {
                return translation.get("contact_validated_cl_type_required");
            },
            validation(c) {
                const v = c?.extension?.type;
                const opts = _DOMAIN_CONTACT_REQUIREMENTS[".cl"].typeOptions;
                return !!opts.find(o => o.id === v);
            },
            extension: true
        },
        id_card_number: {
            invalidHtml(c) {
                return translation.get("contact_validated_id_card_required");
            },
            validation(c) {
                const v = c?.extension?.id_card_number;
                return v && v.length > 0;
            },
            extension: true
        },
        registrant_vat_id: {
            invalidHtml(c) {
                return translation.get("contact_validated_cl_registrant_vat_id_required");
            },
            validation(c) {
                const v = c?.extension?.registrant_vat_id;
                return v && v.length > 0;
            },
            validation(c) {
                return true;
            },
            extension: true
        },
    },
    typeOptions: [
        {
            id: "individual",
            text: "Individual",
            affinity: ["id_card_number"]
        },
        {
            id: "organization",
            text: "Organization",
            affinity: ["registrant_vat_id"]
        }
    ]
  },
  ".co.za": {
      roles: ["registrant"],
      affinity: [
          "type"
      ],
      extraValidation: {
          "type": {
              invalidHtml(c) {
                  return translation.get("contact_validated_co_za_type_required");
              },
              validation(c) {
                  return !![
                      { id: "individual" },
                      { id: "organization" }
                  ].find(i => i.id == (c.extension && c.extension["type"]));
              },
              "extension": true
          },
      },
      "typeOptions": [
           {
               id: "individual",
               text: "Individual",
               affinity: ["id_card_number"]
           },
           {
               id: "organization",
               text: "Organization",
               affinity: ["registration_number","registrant_vat_id"]
           }
      ]
  },
  ".com": {
      roles: ["registrant"]
  },
  ".com.au": {
    roles: ["registrant"],
    dacMessage: translation.get("contact_validated_au_dacMessage"),

    affinity: ["type"],

    extraValidation: {
      cc: {
        invalidHtml(c) { return translation.get("contact_validated_au_cc_required"); },
        validation(c) { return c?.postalInfo?.addr?.cc === "AU"; },
        extension: true
      },

      type: {
        invalidHtml(c) { return translation.get("contact_validated_au_type_required"); },
        getOptions(c) {
          return _DOMAIN_CONTACT_REQUIREMENTS[".com.au"].typeOptions || [];
        },
        validation(c) {
          const v = c?.extension?.type;
          const opts = _DOMAIN_CONTACT_REQUIREMENTS[".com.au"].typeOptions || [];
          return !!opts.find(o => o.id === v);
        },
        extension: true
      },

      eligibility_name: {
        invalidHtml(c) { return translation.get("contact_validated_au_eligibility_name_required"); },
        validation(c) {
          const v = c?.extension?.eligibility_name;
          return typeof v === "string" && v.trim().length > 0;
        },
        extension: true
      },

      eligibility_id_type: {
        invalidHtml(c) { return translation.get("contact_validated_au_eligibility_id_type_required"); },

        getOptions(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return [];

          const allowedByTypeText = {
            "Company":        ["ACN", "ABN"],
            "Trademark Owner":  ["TM"],
            "Pending TM Owner": ["TM"],
          };
          const values = allowedByTypeText[typeText] || ["ABN"];
          return values.map(id => ({ id, text: id }));
        },

        validation(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return true;

          const v = c?.extension?.eligibility_id_type;
          if (typeof v !== "string" || v.trim().length === 0) return false;

          const opts = _DOMAIN_CONTACT_REQUIREMENTS[".com.au"]["extraValidation"]["eligibility_id_type"].getOptions(c) || [];
          return opts.some(o => o.id === v);
        },
        extension: true
      },

      eligibility_id: {
        invalidHtml(c) { return translation.get("contact_validated_au_eligibility_id_required"); },
        validation(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return true;

          const v = c?.extension?.eligibility_id;
          return typeof v === "string" && v.trim().length > 0;
        },
        extension: true
      },

      policy_reason: {
        invalidHtml(c) { return translation.get("contact_validated_au_policy_reason_required"); },

        getOptions(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return [];

          return [
            { id: "1", text: "1 — Exact match to acronym/abbreviation or trademark" },
            { id: "2", text: "2 — Closely and substantially connected to the registrant (default)" }
          ];
        },

        validation(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return true;

          const v = c?.extension?.policy_reason;
          const opts = _DOMAIN_CONTACT_REQUIREMENTS[".com.au"]["extraValidation"]["policy_reason"].getOptions(c) || [];
          return opts.some(o => o.id === String(v));
        },
        extension: true
      },

      registrant_id_type: {
        invalidHtml(c) { return translation.get("contact_validated_au_registrant_id_type_required"); },

        getOptions(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return [];

          return [
            { id: "ABN", text: "ABN — Australian Business Number" },
            { id: "ACN", text: "ACN — Australian Company Number" }
          ];
        },

        validation(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return true;

          const v = c?.extension?.registrant_id_type;
          const opts = _DOMAIN_CONTACT_REQUIREMENTS[".com.au"]["extraValidation"]["registrant_id_type"].getOptions(c) || [];
          return opts.some(o => o.id === v);
        },
        extension: true
      },

      registrant_id: {
        invalidHtml(c) { return translation.get("contact_validated_au_registrant_id_required"); },
        validation(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return true;

          const v = c?.extension?.registrant_id;
          return typeof v === "string" && v.trim().length > 0;
        },
        extension: true
      },

      priority_contact_id: {
        invalidHtml(c) { return translation.get("contact_validated_au_priority_contact_id_required"); },
        validation(c) {
          const v = c?.extension?.priority_contact_id;
          return (v === undefined || v === null || v === "")
            ? true
            : (typeof v === "string" && v.trim().length > 0);
        },
        extension: true
      },

      priority_auth_info: {
        invalidHtml(c) { return translation.get("contact_validated_au_priority_auth_info_required"); },
        validation(c) {
          const v = c?.extension?.priority_auth_info;
          return (v === undefined || v === null || v === "")
            ? true
            : (typeof v === "string" && v.trim().length > 0);
        },
        extension: true
      },

      sp: {
        invalidHtml(c) { return translation.get("contact_validated_au_sp_required"); },
        validation(c) { return _DOMAIN_CONTACT_REQUIREMENTS[".au"].extraValidation.sp.validation(c); }
      },

      pc: {
        invalidHtml(c) { return translation.get("contact_validated_au_pc_invalid"); },
        validation(c) { return _DOMAIN_CONTACT_REQUIREMENTS[".au"].extraValidation.pc.validation(c); }
      }
    },

    // .COM.AU / .NET.AU eligible types
    typeOptions: [
      { id: "Commonwealth entity",            text: "Commonwealth entity",            affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Company",                        text: "Company",                        affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Government Body",                text: "Government Body",                affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Incorporated Association",       text: "Incorporated Association",       affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Partnership",                    text: "Partnership",                    affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Pending TM Owner",               text: "Pending TM Owner",               affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Registered Business",            text: "Registered Business",            affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Sole Trader",                    text: "Sole Trader",                    affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Statutory Body",                 text: "Statutory Body",                 affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Trademark Owner",                text: "Trademark Owner",                affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Trading Cooperative",            text: "Trading Cooperative",            affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Trust",                          text: "Trust",                          affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] }
    ]
  },
  ".net.au": {
    roles: ["registrant"],
    affinity: ["type"],
    extraValidation: {
      cc: {
        invalidHtml(c) { return translation.get("contact_validated_au_cc_required"); },
        validation(c) { return c?.postalInfo?.addr?.cc === "AU"; },
        extension: true
      },
      type: {
        invalidHtml(c) { return translation.get("contact_validated_au_type_required"); },
        getOptions(c) {
          return _DOMAIN_CONTACT_REQUIREMENTS[".net.au"].typeOptions || [];
        },
        validation(c) {
          const v = c?.extension?.type;
          const opts = _DOMAIN_CONTACT_REQUIREMENTS[".net.au"].typeOptions || [];
          return !!opts.find(o => o.id === v);
        },
        extension: true
      },
      eligibility_name: {
        invalidHtml(c) { return translation.get("contact_validated_au_eligibility_name_required"); },
        validation(c) {
          const v = c?.extension?.eligibility_name;
          return typeof v === "string" && v.trim().length > 0;
        },
        extension: true
      },
      eligibility_id_type: {
        invalidHtml(c) { return translation.get("contact_validated_au_eligibility_id_type_required"); },
        getOptions(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return [];

          const allowedByTypeText = {
            "Company":          ["ACN", "ABN"],
            "Trademark Owner":  ["TM"],
            "Pending TM Owner": ["TM"],
          };
          const values = allowedByTypeText[typeText] || ["ABN"];
          return values.map(id => ({ id, text: id }));
        },
        validation(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return true;

          const v = c?.extension?.eligibility_id_type;
          if (typeof v !== "string" || v.trim().length === 0) return false;

          const opts = _DOMAIN_CONTACT_REQUIREMENTS[".net.au"]["extraValidation"]["eligibility_id_type"].getOptions(c) || [];
          return opts.some(o => o.id === v);
        },
        extension: true
      },
      eligibility_id: {
        invalidHtml(c) { return translation.get("contact_validated_au_eligibility_id_required"); },
        validation(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return true;

          const v = c?.extension?.eligibility_id;
          return typeof v === "string" && v.trim().length > 0;
        },
        extension: true
      },
      policy_reason: {
        invalidHtml(c) { return translation.get("contact_validated_au_policy_reason_required"); },
        getOptions(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return [];

          return [
            { id: "1", text: "1 — Exact match to acronym/abbreviation or trademark" },
            { id: "2", text: "2 — Closely and substantially connected to the registrant (default)" }
          ];
        },
        validation(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return true;

          const v = c?.extension?.policy_reason;
          const opts = _DOMAIN_CONTACT_REQUIREMENTS[".net.au"]["extraValidation"]["policy_reason"].getOptions(c) || [];
          return opts.some(o => o.id === String(v));
        },
        extension: true
      },
      registrant_id_type: {
        invalidHtml(c) { return translation.get("contact_validated_au_registrant_id_type_required"); },
        getOptions(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return [];

          return [
            { id: "ABN", text: "ABN — Australian Business Number" },
            { id: "ACN", text: "ACN — Australian Company Number" }
          ];
        },
        validation(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return true;

          const v = c?.extension?.registrant_id_type;
          const opts = _DOMAIN_CONTACT_REQUIREMENTS[".net.au"]["extraValidation"]["registrant_id_type"].getOptions(c) || [];
          return opts.some(o => o.id === v);
        },
        extension: true
      },
      registrant_id: {
        invalidHtml(c) { return translation.get("contact_validated_au_registrant_id_required"); },
        validation(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return true;

          const v = c?.extension?.registrant_id;
          return typeof v === "string" && v.trim().length > 0;
        },
        extension: true
      },
      priority_contact_id: {
        invalidHtml(c) { return translation.get("contact_validated_au_priority_contact_id_required"); },
        validation(c) {
          const v = c?.extension?.priority_contact_id;
          return (v === undefined || v === null || v === "")
            ? true
            : (typeof v === "string" && v.trim().length > 0);
        },
        extension: true
      },
      priority_auth_info: {
        invalidHtml(c) { return translation.get("contact_validated_au_priority_auth_info_required"); },
        validation(c) {
          const v = c?.extension?.priority_auth_info;
          return (v === undefined || v === null || v === "")
            ? true
            : (typeof v === "string" && v.trim().length > 0);
        },
        extension: true
      },

      sp: {
        invalidHtml(c) { return translation.get("contact_validated_au_sp_required"); },
        validation(c) { return _DOMAIN_CONTACT_REQUIREMENTS[".au"].extraValidation.sp.validation(c); }
      },

      pc: {
        invalidHtml(c) { return translation.get("contact_validated_au_pc_invalid"); },
        validation(c) { return _DOMAIN_CONTACT_REQUIREMENTS[".au"].extraValidation.pc.validation(c); }
      }
    },
    // .NET.AU shares eligible types with .COM.AU
    typeOptions: [
      { id: "Commonwealth entity",            text: "Commonwealth entity",            affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Company",                        text: "Company",                        affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Government Body",                text: "Government Body",                affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Incorporated Association",       text: "Incorporated Association",       affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Partnership",                    text: "Partnership",                    affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Pending TM Owner",               text: "Pending TM Owner",               affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Registered Business",            text: "Registered Business",            affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Sole Trader",                    text: "Sole Trader",                    affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Statutory Body",                 text: "Statutory Body",                 affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Trademark Owner",                text: "Trademark Owner",                affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Trading Cooperative",            text: "Trading Cooperative",            affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Trust",                          text: "Trust",                          affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] }
    ]
  },
  ".id.au": {
    roles: ["registrant"],
    affinity: ["type"],
    extraValidation: {
      cc: {
        invalidHtml(c) { return translation.get("contact_validated_au_cc_required"); },
        validation(c) { return c?.postalInfo?.addr?.cc === "AU"; },
        extension: true
      },
      type: {
        invalidHtml(c) { return translation.get("contact_validated_au_type_required"); },
        getOptions(c) {
          return _DOMAIN_CONTACT_REQUIREMENTS[".id.au"].typeOptions || [];
        },
        validation(c) {
          const v = c?.extension?.type;
          const opts = _DOMAIN_CONTACT_REQUIREMENTS[".id.au"].typeOptions || [];
          return !!opts.find(o => o.id === v);
        },
        extension: true
      },
      eligibility_name: {
        invalidHtml(c) { return translation.get("contact_validated_au_eligibility_name_required"); },
        validation(c) {
          const v = c?.extension?.eligibility_name;
          return typeof v === "string" && v.trim().length > 0;
        },
        extension: true
      },
      eligibility_id: {
        invalidHtml(c) { return translation.get("contact_validated_au_eligibility_id_required"); },
        validation(c) {
          // Optional unless eligibility_id_type is specified
          const idType = c?.extension?.eligibility_id_type;
          if (!idType) return true;

          const v = c?.extension?.eligibility_id;
          return typeof v === "string" && v.trim().length > 0;
        },
        extension: true
      },

      sp: {
        invalidHtml(c) { return translation.get("contact_validated_au_sp_required"); },
        validation(c) { return _DOMAIN_CONTACT_REQUIREMENTS[".au"].extraValidation.sp.validation(c); }
      },

      pc: {
        invalidHtml(c) { return translation.get("contact_validated_au_pc_invalid"); },
        validation(c) { return _DOMAIN_CONTACT_REQUIREMENTS[".au"].extraValidation.pc.validation(c); }
      }
    },
    // .ID.AU: individuals only
    typeOptions: [
      { id: "Citizen/Resident", text: "Citizen/Resident", affinity: [] }
    ]
  },
  ".org.au": {
    roles: ["registrant"],
    dacMessage: translation.get("contact_validated_au_dacMessage"),
    affinity: ["type"],
    extraValidation: {
      cc: {
        invalidHtml(c) { return translation.get("contact_validated_au_cc_required"); },
        validation(c) { return c?.postalInfo?.addr?.cc === "AU"; },
        extension: true
      },
      type: {
        invalidHtml(c) { return translation.get("contact_validated_au_type_required"); },
        getOptions(c) {
          return _DOMAIN_CONTACT_REQUIREMENTS[".org.au"].typeOptions || [];
        },
        validation(c) {
          const v = c?.extension?.type;
          const opts = _DOMAIN_CONTACT_REQUIREMENTS[".org.au"].typeOptions || [];
          return !!opts.find(o => o.id === v);
        },
        extension: true
      },
      eligibility_name: {
        invalidHtml(c) { return translation.get("contact_validated_au_eligibility_name_required"); },
        validation(c) {
          const v = c?.extension?.eligibility_name;
          return typeof v === "string" && v.trim().length > 0;
        },
        extension: true
      },
      eligibility_id_type: {
        invalidHtml(c) { return translation.get("contact_validated_au_eligibility_id_type_required"); },
        getOptions(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return [];

          const allowedByTypeText = {
            "Trade Union": ["OTHER"],
          };
          const values = allowedByTypeText[typeText] || ["ABN"];
          return values.map(id => ({ id, text: id }));
        },
        validation(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return true;

          const v = c?.extension?.eligibility_id_type;
          if (typeof v !== "string" || v.trim().length === 0) return false;

          const opts = _DOMAIN_CONTACT_REQUIREMENTS[".org.au"]["extraValidation"]["eligibility_id_type"].getOptions(c) || [];
          return opts.some(o => o.id === v);
        },
        extension: true
      },
      eligibility_id: {
        invalidHtml(c) { return translation.get("contact_validated_au_eligibility_id_required"); },
        validation(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return true;

          const v = c?.extension?.eligibility_id;
          return typeof v === "string" && v.trim().length > 0;
        },
        extension: true
      },
      policy_reason: {
        invalidHtml(c) { return translation.get("contact_validated_au_policy_reason_required"); },
        getOptions(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return [];

          return [
            { id: "1", text: "1 — Exact match to acronym/abbreviation or trademark" },
            { id: "2", text: "2 — Closely and substantially connected to the registrant (default)" }
          ];
        },
        validation(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return true;

          const v = c?.extension?.policy_reason;
          const opts = _DOMAIN_CONTACT_REQUIREMENTS[".org.au"]["extraValidation"]["policy_reason"].getOptions(c) || [];
          return opts.some(o => o.id === String(v));
        },
        extension: true
      },
      registrant_id_type: {
        invalidHtml(c) { return translation.get("contact_validated_au_registrant_id_type_required"); },
        getOptions(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return [];

          return [
            { id: "ABN", text: "ABN — Australian Business Number" },
            { id: "ACN", text: "ACN — Australian Company Number" }
          ];
        },
        validation(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return true;

          const v = c?.extension?.registrant_id_type;
          const opts = _DOMAIN_CONTACT_REQUIREMENTS[".org.au"]["extraValidation"]["registrant_id_type"].getOptions(c) || [];
          return opts.some(o => o.id === v);
        },
        extension: true
      },
      registrant_id: {
        invalidHtml(c) { return translation.get("contact_validated_au_registrant_id_required"); },
        validation(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return true;

          const v = c?.extension?.registrant_id;
          return typeof v === "string" && v.trim().length > 0;
        },
        extension: true
      },
      priority_contact_id: {
        invalidHtml(c) { return translation.get("contact_validated_au_priority_contact_id_required"); },
        validation(c) {
          const v = c?.extension?.priority_contact_id;
          return (v === undefined || v === null || v === "")
            ? true
            : (typeof v === "string" && v.trim().length > 0);
        },
        extension: true
      },
      priority_auth_info: {
        invalidHtml(c) { return translation.get("contact_validated_au_priority_auth_info_required"); },
        validation(c) {
          const v = c?.extension?.priority_auth_info;
          return (v === undefined || v === null || v === "")
            ? true
            : (typeof v === "string" && v.trim().length > 0);
        },
        extension: true
      },

      sp: {
        invalidHtml(c) { return translation.get("contact_validated_au_sp_required"); },
        validation(c) { return _DOMAIN_CONTACT_REQUIREMENTS[".au"].extraValidation.sp.validation(c); }
      },

      pc: {
        invalidHtml(c) { return translation.get("contact_validated_au_pc_invalid"); },
        validation(c) { return _DOMAIN_CONTACT_REQUIREMENTS[".au"].extraValidation.pc.validation(c); }
      }
    },
    // .ORG.AU / .ASN.AU eligible types
    typeOptions: [
      { id: "Charitable Trust",               text: "Charitable Trust",               affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Charity",                        text: "Charity",                        affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Club",                           text: "Club",                           affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Company Limited by Guarantee",   text: "Company Limited by Guarantee",   affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Foreign Embassy or Consulate",   text: "Foreign Embassy or Consulate",   affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Government Body",                text: "Government Body",                affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Incorporated Association",       text: "Incorporated Association",       affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Indigenous Corporation",         text: "Indigenous Corporation",         affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Non-distributing Cooperative",   text: "Non-distributing Cooperative",   affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Non-profit Organisation",        text: "Non-profit Organisation",        affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Non-trading Cooperative",        text: "Non-trading Cooperative",        affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Political Party",                text: "Political Party",                affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Public/Private Ancillary Fund",  text: "Public/Private Ancillary Fund",  affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Registered Organisation",        text: "Registered Organisation",        affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Trade Union",                    text: "Trade Union",                    affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] }
    ]
  },
  ".asn.au": {
    roles: ["registrant"],
    affinity: ["type"],
    extraValidation: {
      cc: {
        invalidHtml(c) { return translation.get("contact_validated_au_cc_required"); },
        validation(c) { return c?.postalInfo?.addr?.cc === "AU"; },
        extension: true
      },
      type: {
        invalidHtml(c) { return translation.get("contact_validated_au_type_required"); },
        getOptions(c) {
          return _DOMAIN_CONTACT_REQUIREMENTS[".asn.au"].typeOptions || [];
        },
        validation(c) {
          const v = c?.extension?.type;
          const opts = _DOMAIN_CONTACT_REQUIREMENTS[".asn.au"].typeOptions || [];
          return !!opts.find(o => o.id === v);
        },
        extension: true
      },
      eligibility_name: {
        invalidHtml(c) { return translation.get("contact_validated_au_eligibility_name_required"); },
        validation(c) {
          const v = c?.extension?.eligibility_name;
          return typeof v === "string" && v.trim().length > 0;
        },
        extension: true
      },
      eligibility_id_type: {
        invalidHtml(c) { return translation.get("contact_validated_au_eligibility_id_type_required"); },
        getOptions(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return [];

          const allowedByTypeText = {
            "Trade Union": ["OTHER"],
          };
          const values = allowedByTypeText[typeText] || ["ABN"];
          return values.map(id => ({ id, text: id }));
        },
        validation(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return true;

          const v = c?.extension?.eligibility_id_type;
          if (typeof v !== "string" || v.trim().length === 0) return false;

          const opts = _DOMAIN_CONTACT_REQUIREMENTS[".asn.au"]["extraValidation"]["eligibility_id_type"].getOptions(c) || [];
          return opts.some(o => o.id === v);
        },
        extension: true
      },
      eligibility_id: {
        invalidHtml(c) { return translation.get("contact_validated_au_eligibility_id_required"); },
        validation(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return true;

          const v = c?.extension?.eligibility_id;
          return typeof v === "string" && v.trim().length > 0;
        },
        extension: true
      },
      policy_reason: {
        invalidHtml(c) { return translation.get("contact_validated_au_policy_reason_required"); },
        getOptions(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return [];

          return [
            { id: "1", text: "1 — Exact match to acronym/abbreviation or trademark" },
            { id: "2", text: "2 — Closely and substantially connected to the registrant (default)" }
          ];
        },
        validation(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return true;

          const v = c?.extension?.policy_reason;
          const opts = _DOMAIN_CONTACT_REQUIREMENTS[".asn.au"]["extraValidation"]["policy_reason"].getOptions(c) || [];
          return opts.some(o => o.id === String(v));
        },
        extension: true
      },
      registrant_id_type: {
        invalidHtml(c) { return translation.get("contact_validated_au_registrant_id_type_required"); },
        getOptions(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return [];

          return [
            { id: "ABN", text: "ABN — Australian Business Number" },
            { id: "ACN", text: "ACN — Australian Company Number" }
          ];
        },
        validation(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return true;

          const v = c?.extension?.registrant_id_type;
          const opts = _DOMAIN_CONTACT_REQUIREMENTS[".asn.au"]["extraValidation"]["registrant_id_type"].getOptions(c) || [];
          return opts.some(o => o.id === v);
        },
        extension: true
      },
      registrant_id: {
        invalidHtml(c) { return translation.get("contact_validated_au_registrant_id_required"); },
        validation(c) {
          const typeText = c?.extension?.type;
          if (!typeText) return true;

          const v = c?.extension?.registrant_id;
          return typeof v === "string" && v.trim().length > 0;
        },
        extension: true
      },
      priority_contact_id: {
        invalidHtml(c) { return translation.get("contact_validated_au_priority_contact_id_required"); },
        validation(c) {
          const v = c?.extension?.priority_contact_id;
          return (v === undefined || v === null || v === "")
            ? true
            : (typeof v === "string" && v.trim().length > 0);
        },
        extension: true
      },
      priority_auth_info: {
        invalidHtml(c) { return translation.get("contact_validated_au_priority_auth_info_required"); },
        validation(c) {
          const v = c?.extension?.priority_auth_info;
          return (v === undefined || v === null || v === "")
            ? true
            : (typeof v === "string" && v.trim().length > 0);
        },
        extension: true
      },
      sp: {
        invalidHtml(c) { return translation.get("contact_validated_au_sp_required"); },
        validation(c) { return _DOMAIN_CONTACT_REQUIREMENTS[".au"].extraValidation.sp.validation(c); }
      },
      pc: {
        invalidHtml(c) { return translation.get("contact_validated_au_pc_invalid"); },
        validation(c) { return _DOMAIN_CONTACT_REQUIREMENTS[".au"].extraValidation.pc.validation(c); }
      }
    },
    // .ASN.AU shares eligible types with .ORG.AU
    typeOptions: [
      { id: "Charitable Trust",               text: "Charitable Trust",               affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Charity",                        text: "Charity",                        affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Club",                           text: "Club",                           affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Company Limited by Guarantee",   text: "Company Limited by Guarantee",   affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Foreign Embassy or Consulate",   text: "Foreign Embassy or Consulate",   affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Government Body",                text: "Government Body",                affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Incorporated Association",       text: "Incorporated Association",       affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Indigenous Corporation",         text: "Indigenous Corporation",         affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Non-distributing Cooperative",   text: "Non-distributing Cooperative",   affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Non-profit Organisation",        text: "Non-profit Organisation",        affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Non-trading Cooperative",        text: "Non-trading Cooperative",        affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Political Party",                text: "Political Party",                affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Public/Private Ancillary Fund",  text: "Public/Private Ancillary Fund",  affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Registered Organisation",        text: "Registered Organisation",        affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] },
      { id: "Trade Union",                    text: "Trade Union",                    affinity: ["eligibility_id_type","eligibility_id","policy_reason","registrant_id_type","registrant_id"] }
    ]
  },
  ".com.br": {
      roles: ["registrant"],
      dacMessage: translation.get("contact_validated_com_br_dacMessage"),
      affinity: ["type"],
      extraValidation: {
          "type": {
              invalidHtml(c) {
                  return translation.get("contact_validated_pt_registrant_type_required");
              },
              validation(c) {
                  return !![
                      { id: "individual" },
                      { id: "organization" }
                  ].find(i => i.id == (c.extension && c.extension["type"]));
              },
              "extension": true
          },
          "cc": {
              invalidHtml(c) {
                  return translation.get("contact_validated_com_br_cc_must_be_br");
              },
              validation(c) {
                  return c.postalInfo.addr.cc == "BR";
              }
          },
          "br_register_number": {
              invalidHtml(c) {
                  if (c.extension["type"] == "individual") {
                      return "Individual Tax Number/Cadastro de Pessoa Fisica required.";
                  } else if (c.extension["type"] == "organization") {
                      return "Business Identifier/Cadastro Nacional de Pessoa Juridica required.";
                  }
              },
              validation(c) {
                  if (c.extension["type"] == "individual") {
                      return (
                          c.extension["br_register_number"] &&
                          /^(?:\d{11}|\d{3}\.\d{3}\.\d{3}-\d{2})$/.test(c.extension["br_register_number"])
                      );
                  } else if (c.extension["type"] == "organization") {
                      return (
                          c.extension["br_register_number"] &&
                          /^(?:\d{14}|\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2})$/.test(c.extension["br_register_number"])
                      );
                  }
                  return false;
              },
              "extension": true
          },
          "sp": {
              invalidHtml(c) {
                  return translation.get("contact_validated_br_sp_required");
              },
              validation(c) {
                  if (c.postalInfo.addr.cc == "BR") {
                      return !!_DOMAIN_CONTACT_REQUIREMENTS[".com.br"].provinces.find(o => o.code == c.postalInfo.addr.sp);
                  }
                  return true;
              }
          }
      },
      "typeOptions": [
          {
              id: "individual",
              text: "Individual",
              affinity: ["br_register_number"]
          },
          {
              id: "organization",
              text: "Organization",
              affinity: ["br_register_number"]
          }
      ],
      "regions": [
          {"code": "1", "name": "Norte"},
          {"code": "2", "name": "Nordeste"},
          {"code": "3", "name": "Sudeste"},
          {"code": "4", "name": "Sul"},
          {"code": "5", "name": "Centro-Oeste"}
      ],
      "provinces": [
          {"code": "AC", "name": "Acre",                "reg": "1"},
          {"code": "AP", "name": "Amapá",               "reg": "1"},
          {"code": "AM", "name": "Amazonas",            "reg": "1"},
          {"code": "PA", "name": "Pará",                "reg": "1"},
          {"code": "RO", "name": "Rondônia",            "reg": "1"},
          {"code": "RR", "name": "Roraima",             "reg": "1"},
          {"code": "TO", "name": "Tocantins",           "reg": "1"},
          {"code": "AL", "name": "Alagoas",             "reg": "2"},
          {"code": "BA", "name": "Bahia",               "reg": "2"},
          {"code": "CE", "name": "Ceará",               "reg": "2"},
          {"code": "MA", "name": "Maranhão",            "reg": "2"},
          {"code": "PB", "name": "Paraíba",             "reg": "2"},
          {"code": "PE", "name": "Pernambuco",          "reg": "2"},
          {"code": "PI", "name": "Piauí",               "reg": "2"},
          {"code": "RN", "name": "Rio Grande do Norte", "reg": "2"},
          {"code": "SE", "name": "Sergipe",             "reg": "2"},
          {"code": "ES", "name": "Espírito Santo",      "reg": "3"},
          {"code": "MG", "name": "Minas Gerais",        "reg": "3"},
          {"code": "RJ", "name": "Rio de Janeiro",      "reg": "3"},
          {"code": "SP", "name": "São Paulo",           "reg": "3"},
          {"code": "PR", "name": "Paraná",              "reg": "4"},
          {"code": "RS", "name": "Rio Grande do Sul",   "reg": "4"},
          {"code": "SC", "name": "Santa Catarina",      "reg": "4"},
          {"code": "DF", "name": "Distrito Federal",    "reg": "5"},
          {"code": "GO", "name": "Goiás",               "reg": "5"},
          {"code": "MT", "name": "Mato Grosso",         "reg": "5"},
          {"code": "MS", "name": "Mato Grosso do Sul",  "reg": "5"}
      ]

  },
  ".com.pt": {
      roles: ["registrant"],
      affinity: ["type"],
      dacMessage: translation.get("contact_validated_pt_dacMessage"),
      extraValidation: {
          "type": {
              invalidHtml(c) {
                  return translation.get("contact_validated_pt_registrant_type_required");
              },
              validation(c) {
                  return !![
                      { id: "individual" },
                      { id: "organization" }
                  ].find(i => i.id == (c.extension && c.extension["type"]));
              },
              "extension": true
          },

          "tax_number": {
              invalidHtml(c) {
                  return translation.get("contact_validated_pt_tax_number_required");
              },
              validation(c) {
                  const v = c.extension && c.extension["tax_number"];
                  return typeof v === "string" && v.length > 0;
              },
              "extension": true
          },

          "id_card_number": {
              invalidHtml(c) {
                  return translation.get("contact_validated_id_card_required");
              },
              validation(c) {
                  const type = c.extension && c.extension["type"];
                  const v = c.extension && c.extension["id_card_number"];

                  if (type === "individual") {
                      return typeof v === "string" && v.length > 0;
                  }

                  // "sometimes" behaviour for organization
                  return true;
              },
              "extension": true
          },
      },
      "typeOptions": [
          {
              id: "individual",
              text: "Individual",
              affinity: ["id_card_number", "tax_number"]
          },
          {
              id: "organization",
              text: "Organization",
              affinity: ["tax_number"]
          }
      ]
  },
  ".com.ro": {
      roles: ["registrant"],
      affinity: [
          "type"
      ],
      extraValidation: {
          "type": {
              invalidHtml(c) {
                  return translation.get("contact_validated_se_registrant_type_required");
              },
              validation(c) {
                  return !![
                      { id: "individual" },
                      { id: "organization" }
                  ].find(i => i.id == (c.extension && c.extension["type"]));
              },
              "extension": true
          },
          "registrant_vat_id": {
              invalidHtml(c) {
                  return translation.get("contact_validated_se_vat_required");
              },
              validation(c) {
                  const type = c.extension && c.extension["type"];
                  const v = c.extension && c.extension["registrant_vat_id"];

                  if (type === "organization") {
                      return typeof v === "string" && v.length > 0;
                  }

                  return true; // sometimes
              },
              "extension": true
          },
          "registration_number": {
              invalidHtml(c) {
                  return translation.get("contact_validated_se_registration_number_required");
              },
              validation(c) {
                  const type = c.extension && c.extension["type"];
                  const v = c.extension && c.extension["registration_number"];

                  if (type === "organization") {
                      return typeof v === "string" && v.length > 0;
                  }

                  return true;
              },
              "extension": true
          },
          "id_card_number": {
              invalidHtml(c) {
                  return translation.get("contact_validated_id_card_required");
              },
              validation(c) {
                  const type = c.extension && c.extension["type"];
                  const v = c.extension && c.extension["id_card_number"];

                  if (type === "individual") {
                      return typeof v === "string" && v.length > 0;
                  }

                  return true;
              },
              "extension": true
          }
      },
      "typeOptions": [
           {
               id: "individual",
               text: "Individual",
               affinity: ["id_card_number"]
           },
           {
               id: "organization",
               text: "Organization",
               affinity: ["registration_number","registrant_vat_id"]
           }
      ]
  },
  ".de": {
    roles: ["registrant"],

    affinity: ["type"],

    extraValidation: {
        type: {
            invalidHtml(c) {
                return translation.get("contact_validated_de_type_required");
            },
            validation(c) {
                const v = c?.extension?.type;
                const opts = _DOMAIN_CONTACT_REQUIREMENTS[".de"].typeOptions;
                return !!opts.find(o => o.id === v);
            },
            extension: true
        },
    },
    typeOptions: [
        {
            id: "individual",
            text: "Individual"
        },
        {
            id: "organization",
            text: "Organization"
        }
    ]
  },
  ".dk": {
      roles: ["registrant"],
      dacMessage: translation.get("contact_validated_dk_dacMessage"),
      affinity: ["type"],
      extraValidation: {

          "type": {
              invalidHtml(c) {
                  return translation.get("contact_validated_dk_type_required");
              },
              validation(c) {
                  return !![
                      { id: "individual" },
                      { id: "organization" }
                  ].find(i => i.id == (c.extension && c.extension["type"]));
              },
              "extension": true
          },
          "registrant_vat_id": {
              invalidHtml(c) {
                  return translation.get("contact_validated_dk_registrant_vat_id_required");
              },
              validation(c) {
                  const type = c.extension && c.extension["type"];
                  const v = c.extension && c.extension["registrant_vat_id"];

                  if (type === "organization") {
                      return typeof v === "string" && v.length > 0;
                  }

                  return true;
              },
              "extension": true
          },
      },
      "typeOptions": [
          {
              id: "individual",
              text: "Individual"
          },
          {
              id: "organization",
              text: "Organization",
              affinity: ["registrant_vat_id"]
          }
      ]
  },
  ".edu.mu": {
      roles: ["admin", "registrant", "tech"]
  },
  ".edu.sh": {
      roles: ["admin", "billing", "registrant", "tech"]
  },
  ".edu.vg": {
      roles: ["registrant", "tech"]
  },
  ".es": {
      dacMessage: translation.get("contact_validated_es_dacMessage"),
      affinity: ["type"],
      extraValidation: {
          "type": {
              invalidHtml(c) {
                  return translation.get("contact_validated_es_type_required");
              },
              validation(c) {
                  return ["NIF","NIE","Other"].includes(c.extension['type']);
              },
              "extension": true
          },
          "es_id_number": {
              invalidHtml(c) {
                  return translation.get("contact_validated_es_id_number_required");
              },
              validation(c) {
                  if( ["NIF","NIE"].includes(c.extension['type']) ){
                      return c.extension['es_id_number'] && c.extension['es_id_number'].length > 0;
                  } else {
                      return true;
                  }
              },
              "extension": true
          }
      },
      "typeOptions": [
          {
              id: "NIF",
              text: "NIF",
              affinity: ["es_id_number"]
          },
          {
              id: "NIE",
              text: "NIE",
              affinity: ["es_id_number"]
          },
          {
              id: "Other",
              text: "Other"
          }
      ]
  },
  ".eu": {
      dacMessage: translation.get("contact_validated_eu_dacMessage"),
      affinity: ["language","country_of_citizenship"],
      extraValidation: {
          "cc": {
              invalidHtml(c) {
                  return translation.get("contact_validated_eu_cc_must_be_eea");
              },
              validation(c) {
                  return _EEA_COUNTRIES.includes(c.postalInfo.addr.cc);
              }
          },
          "country_of_citizenship": {
              invalidHtml(c) {
                  return translation.get("contact_validated_eu_country_of_citizenship_required");
              },
              validation(c) {
                  return !!_EU_NATIONALITIES.find(i=>i.id == c.extension['country_of_citizenship']);
              },
              getOptions(c) {
                  return _EU_NATIONALITIES;
              },
              "extension": true
          },
          "language": {
              invalidHtml(c) {
                  return translation.get("contact_validated_eu_language_required");
              },
              validation(c) {
                  return !!_EU_NATIONALITIES.find(i=>i.id == c.extension['language']);
              },
              getOptions(c) {
                  return _EU_NATIONALITIES;
              },
              "extension": true
          },
      }
  },
  ".fans": {
      roles: ["registrant", "tech"]
  },
  ".fi": {
      roles: ["registrant"],
      dacMessage: translation.get("contact_validated_fi_dacMessage"),
      affinity: ["type"],
      extraValidation: {

          "type": {
              invalidHtml(c) {
                  return translation.get("contact_validated_fi_type_required");
              },
              validation(c) {
                  return !![
                      { id: "individual" },
                      { id: "organization" }
                  ].find(i => i.id == (c.extension && c.extension["type"]));
              },
              "extension": true
          },
          "registration_number": {
              invalidHtml(c) {
                  return translation.get("contact_validated_fi_registration_number_required");
              },
              validation(c) {
                  const type = c.extension && c.extension["type"];
                  const v = c.extension && c.extension["registration_number"];

                  if (type === "organization") {
                      return typeof v === "string" && v.length > 0;
                  }

                  return true;
              },
              "extension": true
          },
          "id_card_number": {
              invalidHtml(c) {
                  return translation.get("contact_validated_fi_id_card_required");
              },
              validation(c) {
                  const type = c.extension && c.extension["type"];
                  const v = c.extension && c.extension["id_card_number"];

                  if (type === "organization") {
                      return typeof v === "string" && v.length > 0;
                  }

                  return true;
              },
              "extension": true
          },
          "date_of_birth": {
              invalidHtml(c) {
                  return translation.get("contact_validated_fi_date_of_birth_required");
              },
              validation(c) {
                  const type = c.extension && c.extension["type"];
                  const v = c.extension && c.extension["date_of_birth"];

                  if (type === "individual") {
                      if (typeof v !== "string") return false;
                      if (!/^\d{4}-\d{2}-\d{2}$/.test(v)) return false;
                  }

                  return true;
              },
              "extension": true
          },
      },
      "typeOptions": [
          {
              id: "individual",
              text: "Individual",
              affinity: ["date_of_birth"]
          },
          {
              id: "organization",
              text: "Organization",
              affinity: ["id_card_number","registration_number"]
          }
      ]
  },
  ".fm": {
      roles: ["registrant", "tech"]
  },
  ".fo": {
      roles: ["registrant", "tech"]
  },
  ".fr": {
    roles: ["registrant"],

    affinity: ["type"],

    extraValidation: {
        type: {
            invalidHtml(c) {
                return translation.get("contact_validated_fr_type_required");
            },
            validation(c) {
                const v = c?.extension?.type;
                return ["individual","organization"].includes(v);
            },
            extension: true
        },
    },
    typeOptions: [
        {
            id: "individual",
            text: "Individual"
        },
        {
            id: "organization",
            text: "Organization"
        }
    ]
  },
  ".frl": {
      roles: ["registrant", "tech"]
  },
  ".ga": {
      roles: ["admin", "billing", "registrant", "tech"]
  },
  ".gd": {
      roles: ["registrant", "tech"]
  },
  ".gent": {
      roles: ["registrant", "tech"]
  },
  ".gl": {
      roles: ["registrant", "tech"]
  },
  ".gov.ac": {
      roles: ["admin", "billing", "registrant", "tech"]
  },
  ".gov.gl": {
      roles: ["registrant", "tech"]
  },
  ".gov.io": {
      roles: ["admin", "billing", "registrant", "tech"]
  },
  ".gov.sh": {
      roles: ["admin", "billing", "registrant", "tech"]
  },
  ".gr.com": {
      roles: ["registrant", "tech"]
  },
  ".hamburg": {
      roles: ["admin", "registrant", "tech"]
  },
  ".hu": {
      roles: ["registrant"],
      dacMessage: translation.get("contact_validated_hu_dacMessage"),
      affinity: [
          "type",
      ],
      extraValidation: {
          "type": {
              invalidHtml(c) {
                  return translation.get("contact_validated_hu_type_required");
              },
              validation(c) {
                  return !![
                      { id: "individual" },
                      { id: "organization" }
                  ].find(i => i.id == (c.extension && c.extension["type"]));
              },
              "extension": true
          },

          "registrant_vat_id": {
              invalidHtml(c) {
                  return translation.get("contact_validated_hu_registrant_vat_id_required");
              },
              validation(c) {
                  const type = c.extension && c.extension["type"];
                  const v = c.extension && c.extension["registrant_vat_id"];

                  if (type === "organization") {
                      return typeof v === "string" && v.length > 0;
                  }

                  return true; // sometimes
              },
              "extension": true
          },
          "id_card_number": {
              invalidHtml(c) {
                  return translation.get("contact_validated_hu_id_card_required");
              },
              validation(c) {
                  const type = c.extension && c.extension["type"];
                  const v = c.extension && c.extension["id_card_number"];

                  if (type === "individual") {
                      return typeof v === "string" && v.length > 0;
                  }

                  return true;
              },
              "extension": true
          }
      },
      "typeOptions": [
           {
               id: "individual",
               text: "Individual",
               affinity: ["id_card_number"]

           },
           {
               id: "organization",
               text: "Organization",
               affinity: ["registrant_vat_id"]
           }
      ]
  },
  ".icu": {
      roles: ["registrant", "tech"]
  },
  ".ie": {
      roles: ["registrant","admin"],
      defaultType: "OTH",
      extraValidation: {
          "sp": {
              invalidHtml(c) {
                  return translation.get("contact_validated_ie_valid_sp_required");
              },
              validation(c) {
                  return c.postalInfo.addr.sp && c.postalInfo.addr.sp.length > 0;
              }
          },
          "pc": {
              invalidHtml(c) {
                  return translation.get("contact_validated_ie_valid_pc_required");
              },
              validation(c) {
                  if(
                      ["GB", "IE", "CA", "US"].includes(c.postalInfo.addr.cc)
                  ) {
                      return c.postalInfo.addr.pc && c.postalInfo.addr.pc.length > 0;
                  } else {
                      return true;
                  }
              }
          },
          "cro-number": {
              invalidHtml(c) {
                  return translation.get("contact_validated_ie_cro_number_required");
              },
              validation(c) {
                  let type = _DOMAIN_CONTACT_REQUIREMENTS[".ie"].typeOptions.find(i => i.id == c.extension.type );
                  if( type && type.affinity && !type.affinity.includes("cro-number") ){
                      // Not required at this time
                      return true;
                  }

                  if( !c.extension || !c.extension['cro-number'] ){
                      return false;
                  } else {
                      return c.extension['cro-number'] === "n/a" || /^\d{6,}$/.test(c.extension['cro-number']);
                  }
              },
              "extension": true
          },
          "supporting-number": {
              invalidHtml(c) {
                  return translation.get("contact_validated_ie_supporting_number_required");
              },
              validation(c) {
                  let type = _DOMAIN_CONTACT_REQUIREMENTS[".ie"].typeOptions.find(i => i.id == c.extension.type );
                  if( type && type.affinity && !type.affinity.includes("supporting-number") ){
                      // Not required at this time
                      return true;
                  }

                  if( !c.extension || !c.extension['supporting-number'] ){
                      return false;
                  } else {
                      return c.extension['cro-number'] == "n/a" || c.extension['cro-number'].length == 6;
                  }
              },
              "extension": true
          },
          "language": {
              invalidHtml(c) {
                  return translation.get("contact_validated_ie_language_required");
              },
              validation(c) {
                  return !![
                      {
                          id: "en"
                      },
                      {
                          id: "fr"
                      }
                  ].find(i=>i.id == c.extension['language']);
              },
              getOptions(c) {
                  return [
                      {
                          text: "English",
                          id: "en"
                      },
                      {
                          text: "French",
                          id: "fr"
                      }
                  ];
              },
              "extension": true
          },
      },
      "typeOptions": [
          {
              id: "OTH",
              text: "Other entity",
              affinity: ["language","org"]
          },
          {
              id: "COM",
              text: "Registered company",
              affinity: ["cro-number","language","org"]
          },
          {
              id: "CHA",
              text: "Registered charity",
              affinity: ["supporting-number","language", "org"]
          }
      ]
  },
  ".inc": {
      roles: ["registrant", "tech"]
  },
  ".info.bh": {
      roles: ["registrant", "tech"]
  },
  ".info.pr": {
      roles: ["admin", "registrant", "tech"]
  },
  ".io": {
      roles: ["admin", "registrant", "tech"]
  },
  ".isla.pr": {
      roles: ["admin", "registrant", "tech"]
  },
  ".it": {
      dacMessage: translation.get("contact_validated_it_dacMessage"),
      extraValidation: {
          "cc": {
              invalidHtml(c) {
                  return translation.get("contact_validated_it_cc_must_be_eea");
              },
              validation(c) {
                  return [..._EEA_COUNTRIES, 'CH', 'SM', 'VA', 'GB'].includes(c.postalInfo.addr.cc);
              }
          },
          "sp": {
              invalidHtml(c) {
                  return translation.get("contact_validated_it_valid_sp_required");
              },
              validation(c) {
                  if( c.postalInfo.addr.cc == "IT" ){
                      return !!_DOMAIN_CONTACT_REQUIREMENTS[".it"].provinces.find(o => o.code == c.postalInfo.addr.sp );
                  } else {
                      return true;
                  }
              }
          },
          "reg_code": {
              invalidHtml(c) {
                  switch(c.extension.type) {
                      case '1':
                          if (c.cc === 'IT') {
                              return translation.get("contact_validated_it_reg_code_fiscale_required");
                          }
                          return translation.get("contact_validated_it_reg_code_individual_foreign");
                      case '7':
                          if ([..._EEA_COUNTRIES, 'CH', 'SM', 'VA'].includes(c.cc)) {
                              return translation.get("contact_validated_it_reg_code_vat_required");
                          }
                          return translation.get("contact_validated_it_reg_code_org_world");
                      default:
                          return translation.get("contact_validated_it_reg_code_default");
                  }
              },
              validation(c) {
                  let type = _DOMAIN_CONTACT_REQUIREMENTS[".it"].typeOptions.find(i => i.id == c.extension.type );
                  if( type && type.affinity && !type.affinity.includes("reg_code") ){
                      // Not required at this time
                      return true;
                  }

                  if( !c.extension || !c.extension['reg_code'] ){
                      return false;
                  } else {
                      return c.extension['reg_code'] == "n.a." || c.extension['reg_code'] == "N.A." || c.extension['reg_code'].length <= 16;
                  }
              },
              "extension": true
          },
          "type": {
              invalidHtml(c) {
                  return translation.get("contact_validated_it_contact_type_required");
              },
              validation(c) {
                  if( c.extension && c.extension['type'] ){
                      return !!_DOMAIN_CONTACT_REQUIREMENTS[".it"].typeOptions.find(o => o.id == c.extension['type'])
                  } else {
                      return false;
                  }
              },
              "extension": true
          }
      },
      "typeOptions": [
          {
              id: "1",
              text: "Individual",
              affinity: ["org","reg_code"]
          },
          {
              id: "2",
              text: "Italian company / one-man company",
              affinity: ["reg_code"]
          },
          {
              id: "3",
              text: "Italian freelance worker / professional",
              affinity: ["reg_code"]
          },
          {
              id: "4",
              text: "Italian non-profit organisation",
              affinity: ["reg_code"]
          },
          {
              id: "5",
              text: "Italian public organisation",
              affinity: ["reg_code"]
          },
          {
              id: "6",
              text: "Other Italian subject",
              affinity: ["reg_code"]
          },
          {
              id: "7",
              text: "Foreign organisation (outside Italy)",
              affinity: ["org","reg_code"]
          },
      ],
      "regions": [
          {"code": "65", "name": "Abruzzo"},
          {"code": "77", "name": "Basilicata"},
          {"code": "78", "name": "Calabria"},
          {"code": "72", "name": "Campania"},
          {"code": "45", "name": "Emilia-Romagna"},
          {"code": "36", "name": "Friuli-Venezia Giulia"},
          {"code": "62", "name": "Lazio"},
          {"code": "42", "name": "Liguria"},
          {"code": "25", "name": "Lombardia"},
          {"code": "57", "name": "Marche"},
          {"code": "67", "name": "Molise"},
          {"code": "21", "name": "Piemonte"},
          {"code": "75", "name": "Puglia"},
          {"code": "88", "name": "Sardegna"},
          {"code": "82", "name": "Sicilia"},
          {"code": "52", "name": "Toscana"},
          {"code": "32", "name": "Trentino-Alto Adige"},
          {"code": "55", "name": "Umbria"},
          {"code": "23", "name": "Valle d'Aosta"},
          {"code": "34", "name": "Veneto"}
      ],
      "provinces": [
          {"code": "CH", "name": "Chieti", "reg": "65"},
          {"code": "AQ", "name": "L'Aquila", "reg": "65"},
          {"code": "PE", "name": "Pescara", "reg": "65"},
          {"code": "TE", "name": "Teramo", "reg": "65"},
          {"code": "MT", "name": "Matera", "reg": "77"},
          {"code": "PZ", "name": "Potenza", "reg": "77"},
          {"code": "CZ", "name": "Catanzaro", "reg": "78"},
          {"code": "CS", "name": "Cosenza", "reg": "78"},
          {"code": "KR", "name": "Crotone", "reg": "78"},
          {"code": "RC", "name": "Reggio Calabria", "reg": "78"},
          {"code": "VV", "name": "Vibo Valentia", "reg": "78"},
          {"code": "AV", "name": "Avellino", "reg": "72"},
          {"code": "BN", "name": "Benevento", "reg": "72"},
          {"code": "CE", "name": "Caserta", "reg": "72"},
          {"code": "NA", "name": "Napoli", "reg": "72"},
          {"code": "SA", "name": "Salerno", "reg": "72"},
          {"code": "BO", "name": "Bologna", "reg": "45"},
          {"code": "FE", "name": "Ferrara", "reg": "45"},
          {"code": "FC", "name": "Forlì-Cesena", "reg": "45"},
          {"code": "MO", "name": "Modena", "reg": "45"},
          {"code": "PR", "name": "Parma", "reg": "45"},
          {"code": "PC", "name": "Piacenza", "reg": "45"},
          {"code": "RA", "name": "Ravenna", "reg": "45"},
          {"code": "RE", "name": "Reggio Emilia", "reg": "45"},
          {"code": "RN", "name": "Rimini", "reg": "45"},
          {"code": "GO", "name": "Gorizia", "reg": "36"},
          {"code": "PN", "name": "Pordenone", "reg": "36"},
          {"code": "TS", "name": "Trieste", "reg": "36"},
          {"code": "UD", "name": "Udine", "reg": "36"},
          {"code": "FR", "name": "Frosinone", "reg": "62"},
          {"code": "LT", "name": "Latina", "reg": "62"},
          {"code": "RI", "name": "Rieti", "reg": "62"},
          {"code": "RM", "name": "Roma", "reg": "62"},
          {"code": "VT", "name": "Viterbo", "reg": "62"},
          {"code": "GE", "name": "Genova", "reg": "42"},
          {"code": "IM", "name": "Imperia", "reg": "42"},
          {"code": "SP", "name": "La Spezia", "reg": "42"},
          {"code": "SV", "name": "Savona", "reg": "42"},
          {"code": "BG", "name": "Bergamo", "reg": "25"},
          {"code": "BS", "name": "Brescia", "reg": "25"},
          {"code": "CO", "name": "Como", "reg": "25"},
          {"code": "CR", "name": "Cremona", "reg": "25"},
          {"code": "LC", "name": "Lecco", "reg": "25"},
          {"code": "LO", "name": "Lodi", "reg": "25"},
          {"code": "MN", "name": "Mantova", "reg": "25"},
          {"code": "MI", "name": "Milano", "reg": "25"},
          {"code": "MB", "name": "Monza e della Brianza", "reg": "25"},
          {"code": "PV", "name": "Pavia", "reg": "25"},
          {"code": "SO", "name": "Sondrio", "reg": "25"},
          {"code": "VA", "name": "Varese", "reg": "25"},
          {"code": "AN", "name": "Ancona", "reg": "57"},
          {"code": "AP", "name": "Ascoli Piceno", "reg": "57"},
          {"code": "FM", "name": "Fermo", "reg": "57"},
          {"code": "MC", "name": "Macerata", "reg": "57"},
          {"code": "PU", "name": "Pesaro e Urbino", "reg": "57"},
          {"code": "CB", "name": "Campobasso", "reg": "67"},
          {"code": "IS", "name": "Isernia", "reg": "67"},
          {"code": "AL", "name": "Alessandria", "reg": "21"},
          {"code": "AT", "name": "Asti", "reg": "21"},
          {"code": "BI", "name": "Biella", "reg": "21"},
          {"code": "CN", "name": "Cuneo", "reg": "21"},
          {"code": "NO", "name": "Novara", "reg": "21"},
          {"code": "TO", "name": "Torino", "reg": "21"},
          {"code": "VB", "name": "Verbano-Cusio-Ossola", "reg": "21"},
          {"code": "VC", "name": "Vercelli", "reg": "21"},
          {"code": "BA", "name": "Bari", "reg": "75"},
          {"code": "BT", "name": "Barletta-Andria-Trani", "reg": "75"},
          {"code": "BR", "name": "Brindisi", "reg": "75"},
          {"code": "FG", "name": "Foggia", "reg": "75"},
          {"code": "LE", "name": "Lecce", "reg": "75"},
          {"code": "TA", "name": "Taranto", "reg": "75"},
          {"code": "CA", "name": "Cagliari", "reg": "88"},
          {"code": "NU", "name": "Nuoro", "reg": "88"},
          {"code": "OR", "name": "Oristano", "reg": "88"},
          {"code": "SS", "name": "Sassari", "reg": "88"},
          {"code": "SU", "name": "Sud Sardegna", "reg": "88"},
          {"code": "AG", "name": "Agrigento", "reg": "82"},
          {"code": "CL", "name": "Caltanissetta", "reg": "82"},
          {"code": "CT", "name": "Catania", "reg": "82"},
          {"code": "EN", "name": "Enna", "reg": "82"},
          {"code": "ME", "name": "Messina", "reg": "82"},
          {"code": "PA", "name": "Palermo", "reg": "82"},
          {"code": "RG", "name": "Ragusa", "reg": "82"},
          {"code": "SR", "name": "Siracusa", "reg": "82"},
          {"code": "TP", "name": "Trapani", "reg": "82"},
          {"code": "AR", "name": "Arezzo", "reg": "52"},
          {"code": "FI", "name": "Firenze", "reg": "52"},
          {"code": "GR", "name": "Grosseto", "reg": "52"},
          {"code": "LI", "name": "Livorno", "reg": "52"},
          {"code": "LU", "name": "Lucca", "reg": "52"},
          {"code": "MS", "name": "Massa-Carrara", "reg": "52"},
          {"code": "PI", "name": "Pisa", "reg": "52"},
          {"code": "PT", "name": "Pistoia", "reg": "52"},
          {"code": "PO", "name": "Prato", "reg": "52"},
          {"code": "SI", "name": "Siena", "reg": "52"},
          {"code": "BZ", "name": "Bolzano", "reg": "32"},
          {"code": "TN", "name": "Trento", "reg": "32"},
          {"code": "PG", "name": "Perugia", "reg": "55"},
          {"code": "TR", "name": "Terni", "reg": "55"},
          {"code": "AO", "name": "Aosta", "reg": "23"},
          {"code": "BL", "name": "Belluno", "reg": "34"},
          {"code": "PD", "name": "Padova", "reg": "34"},
          {"code": "RO", "name": "Rovigo", "reg": "34"},
          {"code": "TV", "name": "Treviso", "reg": "34"},
          {"code": "VE", "name": "Venezia", "reg": "34"},
          {"code": "VI", "name": "Vicenza", "reg": "34"},
          {"code": "VR", "name": "Verona", "reg": "34"}
      ],
  },
  ".jobs": {
      roles: ["registrant"],
      dacMessage: translation.get("contact_validated_jobs_dacMessage"),
      affinity: ["type"],
      extraValidation: {
          jobs_website: {
              invalidHtml(c) {
                  return translation.get("contact_validated_jobs_website_required");
              },
              validation(c) {
                  const jobsWebsiteRegex = /^https?:\/\/.+\..+$/; // FIXME good enough for now.
                  return c.extension.jobs_website && c.extension.jobs_website.length > 5 && jobsWebsiteRegex.test(c.extension.jobs_website);
              },
              "extension": true
          },
          jobs_association_member: {
              invalidHtml(c) {
                  return translation.get("contact_validated_jobs_association_member_required");
              },
              getOptions(c) {
                return [
                    {
                        id: "Yes",
                        text: "Yes"
                    },
                    {
                        id: "No",
                        text: "No"
                    }
                ];
              },
              validation(c) {
                  return !!_DOMAIN_CONTACT_REQUIREMENTS[".jobs"]['extraValidation']['jobs_association_member'].getOptions(c).find(i => i.id == c.extension.jobs_association_member);
              },
              "extension": true
          },
          jobs_admin_type: {
              invalidHtml(c) {
                  return translation.get("contact_validated_jobs_admin_type_required");
              },
              getOptions(c) {
                return [
                    {
                        id: "Yes",
                        text: "Yes"
                    },
                    {
                        id: "No",
                        text: "No"
                    }
                ];
              },
              validation(c) {
                  return !!_DOMAIN_CONTACT_REQUIREMENTS[".jobs"]['extraValidation']['jobs_association_member'].getOptions(c).find(i => i.id == c.extension.jobs_admin_type);
              },
              "extension": true
          }
      },
      "typeOptions": [
          {
              id: "organization",
              text: "Organization",
              affinity: ["jobs_admin_type","jobs_association_member","jobs_website"]
          }
      ]
  },
  ".jp": {
      roles: ["registrant"],
      dacMessage: translation.get("contact_validated_jp_dacMessage"),
      extraValidation: {
          "cc": {
              invalidHtml(c) {
                  return translation.get("contact_validated_jp_cc_must_be_japan");
              },
              validation(c) {
                  return c.postalInfo.addr.cc == "JP";
              }
          },
          "pc": {
              invalidHtml(c) {
                  return translation.get("contact_validated_jp_pc_invalid");
              },
              validation(c) {
                  let r = new RegExp("^\\d{3}-\\d{4}$");
                  return c.postalInfo.addr.pc.match(r);
              }
          },
          "sp": {
              invalidHtml(c) {
                  return translation.get("contact_validated_jp_sp_invalid");
              },
              validation(c) {
                  if (c.postalInfo.addr.cc == "JP") {
                      return !!_DOMAIN_CONTACT_REQUIREMENTS[".jp"].provinces.find(o => o.code == c.postalInfo.addr.sp);
                  }
                  return true;
              }
          }
      },
      "regions": [
          {"code": "R01", "name": "Hokkaido"},
          {"code": "R02", "name": "Tohoku"},
          {"code": "R03", "name": "Kanto"},
          {"code": "R04", "name": "Chubu"},
          {"code": "R05", "name": "Kansai"},
          {"code": "R06", "name": "Chugoku"},
          {"code": "R07", "name": "Shikoku"},
          {"code": "R08", "name": "Kyushu"}
      ],
      "provinces": [
          {"code": "Hokkaido", "name": "Hokkaido", "reg": "R01"},
          {"code": "Aomori", "name": "Aomori", "reg": "R02"},
          {"code": "Iwate", "name": "Iwate", "reg": "R02"},
          {"code": "Miyagi", "name": "Miyagi", "reg": "R02"},
          {"code": "Akita", "name": "Akita", "reg": "R02"},
          {"code": "Yamagata", "name": "Yamagata", "reg": "R02"},
          {"code": "Fukushima", "name": "Fukushima", "reg": "R02"},
          {"code": "Ibaraki", "name": "Ibaraki", "reg": "R03"},
          {"code": "Tochigi", "name": "Tochigi", "reg": "R03"},
          {"code": "Gunma", "name": "Gunma", "reg": "R03"},
          {"code": "Saitama", "name": "Saitama", "reg": "R03"},
          {"code": "Chiba", "name": "Chiba", "reg": "R03"},
          {"code": "Tokyo", "name": "Tokyo", "reg": "R03"},
          {"code": "Kanagawa", "name": "Kanagawa", "reg": "R03"},
          {"code": "Niigata", "name": "Niigata", "reg": "R04"},
          {"code": "Toyama", "name": "Toyama", "reg": "R04"},
          {"code": "Ishikawa", "name": "Ishikawa", "reg": "R04"},
          {"code": "Fukui", "name": "Fukui", "reg": "R04"},
          {"code": "Yamanashi", "name": "Yamanashi", "reg": "R04"},
          {"code": "Nagano", "name": "Nagano", "reg": "R04"},
          {"code": "Gifu", "name": "Gifu", "reg": "R04"},
          {"code": "Shizuoka", "name": "Shizuoka", "reg": "R04"},
          {"code": "Aichi", "name": "Aichi", "reg": "R04"},
          {"code": "Mie", "name": "Mie", "reg": "R05"},
          {"code": "Shiga", "name": "Shiga", "reg": "R05"},
          {"code": "Kyoto", "name": "Kyoto", "reg": "R05"},
          {"code": "Osaka", "name": "Osaka", "reg": "R05"},
          {"code": "Hyogo", "name": "Hyogo", "reg": "R05"},
          {"code": "Nara", "name": "Nara", "reg": "R05"},
          {"code": "Wakayama", "name": "Wakayama", "reg": "R05"},
          {"code": "Tottori", "name": "Tottori", "reg": "R06"},
          {"code": "Shimane", "name": "Shimane", "reg": "R06"},
          {"code": "Okayama", "name": "Okayama", "reg": "R06"},
          {"code": "Hiroshima", "name": "Hiroshima", "reg": "R06"},
          {"code": "Yamaguchi", "name": "Yamaguchi", "reg": "R06"},
          {"code": "Tokushima", "name": "Tokushima", "reg": "R07"},
          {"code": "Kagawa", "name": "Kagawa", "reg": "R07"},
          {"code": "Ehime", "name": "Ehime", "reg": "R07"},
          {"code": "Kochi", "name": "Kochi", "reg": "R07"},
          {"code": "Fukuoka", "name": "Fukuoka", "reg": "R08"},
          {"code": "Saga", "name": "Saga", "reg": "R08"},
          {"code": "Nagasaki", "name": "Nagasaki", "reg": "R08"},
          {"code": "Kumamoto", "name": "Kumamoto", "reg": "R08"},
          {"code": "Oita", "name": "Oita", "reg": "R08"},
          {"code": "Miyazaki", "name": "Miyazaki", "reg": "R08"},
          {"code": "Kagoshima", "name": "Kagoshima", "reg": "R08"},
          {"code": "Okinawa", "name": "Okinawa", "reg": "R08"}
      ]
  },
  ".kids": {
      roles: ["admin", "registrant", "tech"]
  },
  ".kred": {
      roles: ["registrant", "tech"]
  },
  ".l.lc": {
      roles: ["admin", "registrant", "tech"]
  },
  ".lc": {
      roles: ["admin", "registrant", "tech"]
  },
  ".london": {
      roles: ["registrant", "tech"]
  },
  ".lp": {
      roles: ["registrant", "tech"]
  },
  ".ltda": {
      roles: ["admin", "registrant", "tech"]
  },
  ".luxury": {
      roles: ["registrant", "tech"]
  },
  ".lv": {
      roles: ["registrant"],
      affinity: [
          "type"
      ],
      extraValidation: {

          "type": {
              invalidHtml(c) {
                  return translation.get("contact_validated_lv_type_required");
              },
              validation(c) {
                  return !![
                      { id: "individual" },
                      { id: "organization" }
                  ].find(i => i.id == (c.extension && c.extension["type"]));
              },
              "extension": true
          },

          "registrant_vat_id": {
              // required if organization
              invalidHtml(c) {
                  return translation.get("contact_validated_lv_registrant_vat_id_required");
              },
              validation(c) {
                  const type = c.extension && c.extension["type"];
                  const v = c.extension && c.extension["registrant_vat_id"];

                  if (type === "organization") {
                      return typeof v === "string" && v.length > 0;
                  }

                  return true; // sometimes
              },
              "extension": true
          },

          "registration_number": {
              invalidHtml(c) {
                  return translation.get("contact_validated_lv_registration_number_required");
              },
              validation(c) {
                  const type = c.extension && c.extension["type"];
                  const v = c.extension && c.extension["registration_number"];

                  if (type === "organization") {
                      return typeof v === "string" && v.length > 0;
                  }

                  return true;
              },
              "extension": true
          },

          "id_card_number": {
              invalidHtml(c) {
                  return translation.get("contact_validated_id_card_required");
              },
              validation(c) {
                  const type = c.extension && c.extension["type"];
                  const v = c.extension && c.extension["id_card_number"];

                  if (type === "individual") {
                      return typeof v === "string" && v.length > 0;
                  }

                  return true;
              },
              "extension": true
          }
      },
      "typeOptions": [
           {
               id: "individual",
               text: "Individual",
               affinity: ["id_card_number"]
           },
           {
               id: "organization",
               text: "Organization",
               affinity: ["registration_number","registrant_vat_id"]
           }
      ]
  },
  ".me": {
      roles: ["admin", "registrant", "tech"]
  },
  ".me.bh": {
      roles: ["registrant", "tech"]
  },
  ".med.bh": {
      roles: ["registrant", "tech"]
  },
  ".mil.ac": {
      roles: ["admin", "billing", "registrant", "tech"]
  },
  ".mil.gl": {
      roles: ["registrant", "tech"]
  },
  ".mil.io": {
      roles: ["admin", "billing", "registrant", "tech"]
  },
  ".mil.sh": {
      roles: ["admin", "billing", "registrant", "tech"]
  },
  ".mn": {
      roles: ["registrant", "tech"]
  },
  ".mu": {
      roles: ["admin", "registrant", "tech"]
  },
  ".museum": {
      roles: ["admin", "billing", "registrant", "tech"]
  },
  ".mx": {
      roles: ["registrant"],
      affinity: [
          "type"
      ],
      extraValidation: {
          "type": {
              invalidHtml(c) {
                  return translation.get("contact_validated_mx_type_required");
              },
              validation(c) {
                  return !![
                      { id: "individual" },
                      { id: "organization" }
                  ].find(i => i.id == (c.extension && c.extension["type"]));
              },
              "extension": true
          },
      },
      "typeOptions": [
           {
               id: "individual",
               text: "Individual",
               affinity: ["id_card_number"]
           },
           {
               id: "organization",
               text: "Organization",
               affinity: ["registration_number","registrant_vat_id"]
           }
      ]
  },
  ".my": {
      roles: ["registrant"],
      dacMessage: translation.get("contact_validated_my_dacMessage"),
      affinity: ["type"],
      extraValidation: {

          "type": {
              invalidHtml(c) {
                  return translation.get("contact_validated_my_type_required");
              },
              validation(c) {
                  return !![
                      { id: "individual" },
                      { id: "organization" }
                  ].find(i => i.id == (c.extension && c.extension["type"]));
              },
              "extension": true
          },
          "registration_number": {
              invalidHtml(c) {
                  return translation.get("contact_validated_my_registration_number_required");
              },
              validation(c) {
                  const type = c.extension && c.extension["type"];
                  const v = c.extension && c.extension["registration_number"];

                  if (type === "organization") {
                      return typeof v === "string" && v.length > 0;
                  }

                  return true;
              },
              "extension": true
          },
          "id_card_number": {
              invalidHtml(c) {
                  return translation.get("contact_validated_my_id_card_required");
              },
              validation(c) {
                  const type = c.extension && c.extension["type"];
                  const v = c.extension && c.extension["id_card_number"];

                  if (type === "organization") {
                      return typeof v === "string" && v.length > 0;
                  }

                  return true;
              },
              "extension": true
          },
      },
      "typeOptions": [
          {
              id: "individual",
              text: "Individual"
          },
          {
              id: "organization",
              text: "Organization",
              affinity: ["id_card_number","registration_number"]
          }
      ]
  },
  ".name.bh": {
      roles: ["registrant", "tech"]
  },
  ".name.pr": {
      roles: ["admin", "registrant", "tech"]
  },
  ".net.ac": {
      roles: ["admin", "billing", "registrant", "tech"]
  },
  ".net.ag": {
      roles: ["admin", "registrant", "tech"]
  },
  ".net.ai": {
      roles: ["admin", "registrant", "tech"]
  },
  ".net.bh": {
      roles: ["registrant", "tech"]
  },
  ".net.co": {
      roles: ["registrant", "tech"]
  },
  ".net.gl": {
      roles: ["registrant", "tech"]
  },
  ".net.io": {
      roles: ["admin", "billing", "registrant", "tech"]
  },
  ".net.sc": {
      roles: ["admin", "registrant", "tech"]
  },
  ".net.sh": {
      roles: ["admin", "billing", "registrant", "tech"]
  },
  ".no": {
      affinity: ["fax", "registration_number"],
      dacMessage: translation.get("contact_validated_no_dacMessage"),
      extraValidation: {
          "pc": {
              invalidHtml(c) {
                  return translation.get("contact_validated_no_valid_pc_required");
              },
              validation(c) {
                  return c.postalInfo.addr.pc.match(/^(no|NO|No)-\d+$/);
              },
          },
          "cc": {
              invalidHtml(c) {
                  return translation.get("contact_validated_no_country_must_eq_no");
              },
              validation(c) {
                  return c.postalInfo.addr.cc == "NO";
              },
          },
          "registration_number": {
              invalidHtml(c) {
                  return translation.get("contact_validated_no_registration_number_required");
              },
              validation(c) {
                  const v = c.extension && c.extension["registration_number"];
                  return typeof v === "string" && v.length == 9;
              },
              "extension": true
          }
      }
  },
  ".nom.ac": {
      roles: ["admin", "billing", "registrant", "tech"]
  },
  ".nom.ag": {
      roles: ["admin", "registrant", "tech"]
  },
  ".nom.co": {
      roles: ["registrant", "tech"]
  },
  ".nom.io": {
      roles: ["admin", "billing", "registrant", "tech"]
  },
  ".nom.mu": {
      roles: ["admin", "registrant", "tech"]
  },
  ".nom.sh": {
      roles: ["admin", "billing", "registrant", "tech"]
  },
  ".nu": {
      roles: ["registrant"],
      affinity: [
          "type"
      ],
      extraValidation: {
          "type": {
              invalidHtml(c) {
                  return translation.get("contact_validated_nu_type_required");
              },
              validation(c) {
                  return !![
                      { id: "individual" },
                      { id: "organization" }
                  ].find(i => i.id == (c.extension && c.extension["type"]));
              },
              "extension": true
          },
          "registrant_vat_id": {
              invalidHtml(c) {
                  return translation.get("contact_validated_nu_registrant_vat_id_required");
              },
              validation(c) {
                  const type = c.extension && c.extension["type"];
                  const v = c.extension && c.extension["registrant_vat_id"];

                  if (type === "organization") {
                      return typeof v === "string" && v.length > 0;
                  }

                  return true; // sometimes
              },
              "extension": true
          },
          "registration_number": {
              invalidHtml(c) {
                  return translation.get("contact_validated_nu_registration_number_required");
              },
              validation(c) {
                  const type = c.extension && c.extension["type"];
                  const v = c.extension && c.extension["registration_number"];

                  if (type === "organization") {
                      return typeof v === "string" && v.length > 0;
                  }

                  return true;
              },
              "extension": true
          },
          "id_card_number": {
              invalidHtml(c) {
                  return translation.get("contact_validated_nu_id_card_required");
              },
              validation(c) {
                  const type = c.extension && c.extension["type"];
                  const v = c.extension && c.extension["id_card_number"];

                  if (type === "individual") {
                      return typeof v === "string" && v.length > 0;
                  }

                  return true;
              },
              "extension": true
          }
      },
      "typeOptions": [
           {
               id: "individual",
               text: "Individual",
               affinity: ["id_card_number"]
           },
           {
               id: "organization",
               text: "Organization",
               affinity: ["registration_number","registrant_vat_id"]
           }
      ]
  },
  ".nyc": {
      roles: ["registrant"],
      dacMessage: translation.get("contact_validated_nyc_dacMessage"),
      moreInfoLink: "https://www.ownit.nyc/policies/",
      moreInfoLinkPreText: translation.get("contact_validated_nyc_moreInfoLinkPreText"),
      moreInfoLinkText: translation.get("contact_validated_nyc_moreInfoLinkText"),
      extraValidation: {
          "cc": {
              invalidHtml(c) {
                  return translation.get("contact_validated_nyc_country_must_eq_us");
              },
              validation(c) {
                  return c.postalInfo.addr.cc == "US";
              },
          },
          "sp": {
              invalidHtml(c) {
                  return translation.get("contact_validated_nyc_state_must_eq_ny");
              },
              validation(c) {
                  const sp = (c.postalInfo.addr.sp || "").trim().toLowerCase();
                  return sp === "ny" || sp === "new york";
              },
              getOptions(c) {
                  return [{ id: "NY", text: "New York" }];
              }
          },
          "city": {
              invalidHtml(c) {
                  return translation.get("contact_validated_nyc_borough_required");
              },
              validation(c) {
                  return _isNycBorough(c.postalInfo.addr.city);
              },
              getOptions(c) {
                  return _NYC_BOROUGHS.map(b => ({ id: b.id, text: b.text }));
              }
          },
          "street": {
              invalidHtml(c) {
                  return translation.get("contact_validated_nyc_po_box_not_allowed");
              },
              validation(c) {
                  return !_isPoBoxAddress(c.postalInfo.addr.street);
              },
          }
      }
  },
  ".off.ai": {
      roles: ["admin", "registrant", "tech"]
  },
  ".ooo": {
      roles: ["registrant", "tech"]
  },
  ".or.mu": {
      roles: ["admin", "registrant", "tech"]
  },
  ".org.ac": {
      roles: ["admin", "billing", "registrant", "tech"]
  },
  ".org.ag": {
      roles: ["admin", "registrant", "tech"]
  },
  ".org.ai": {
      roles: ["admin", "registrant", "tech"]
  },
  ".org.bh": {
      roles: ["registrant", "tech"]
  },
  ".org.gl": {
      roles: ["registrant", "tech"]
  },
  ".org.io": {
      roles: ["admin", "billing", "registrant", "tech"]
  },
  ".org.lc": {
      roles: ["admin", "registrant", "tech"]
  },
  ".org.mu": {
      roles: ["admin", "registrant", "tech"]
  },
  ".org.pr": {
      roles: ["admin", "registrant", "tech"]
  },
  ".org.sc": {
      roles: ["admin", "registrant", "tech"]
  },
  ".org.sh": {
      roles: ["admin", "billing", "registrant", "tech"]
  },
  ".p.lc": {
      roles: ["admin", "registrant", "tech"]
  },
  ".paris": {
      roles: ["admin", "billing", "registrant", "tech"]
  },
  ".pm": {
      roles: ["admin", "registrant", "tech"]
  },
  ".pr": {
      roles: ["admin", "registrant", "tech"]
  },
  ".pro": {
      roles: ["registrant"],
      affinity: [
          "authority", "authority_website","license_number","profession"
      ],
      extraValidation: {
          "profession": {
              invalidHtml(c) {
                  return translation.get("contact_validated_pro_profession_required");
              },
              validation(c) {
                  return c.extension['profession']?.length > 0;
              },
              "extension": true
          },
          "license_number": {
              validation(c) {
                  // Optional
                  return true;
              },
              "extension": true
          },
          "authority_website": {
              validation(c) {
                  // Optional
                  return true;
              },
              "extension": true
          },
          "authority": {
              validation(c) {
                  // Optional
                  return true;
              },
              "extension": true
          },
      }
  },
  ".pro.pr": {
      roles: ["admin", "registrant", "tech"]
  },
  ".pt": {
      roles: ["registrant"],
      affinity: ["type"],
      dacMessage: translation.get("contact_validated_pt_dacMessage"),
      extraValidation: {
          "type": {
              invalidHtml(c) {
                  return translation.get("contact_validated_pt_registrant_type_required");
              },
              validation(c) {
                  return !![
                      { id: "individual" },
                      { id: "organization" }
                  ].find(i => i.id == (c.extension && c.extension["type"]));
              },
              "extension": true
          },
          "tax_number": {
              invalidHtml(c) {
                  return translation.get("contact_validated_pt_tax_number_required");
              },
              validation(c) {
                  const v = c.extension && c.extension["tax_number"];
                  return typeof v === "string" && v.length > 0;
              },
              "extension": true
          },
          "id_card_number": {
              invalidHtml(c) {
                  return translation.get("contact_validated_id_card_required");
              },
              validation(c) {
                  const type = c.extension && c.extension["type"];
                  const v = c.extension && c.extension["id_card_number"];

                  if (type === "individual") {
                      return typeof v === "string" && v.length > 0;
                  }

                  // "sometimes" behaviour for organization
                  return true;
              },
              "extension": true
          },
      },
      "typeOptions": [
          {
              id: "individual",
              text: "Individual",
              affinity: ["id_card_number", "tax_number"]
          },
          {
              id: "organization",
              text: "Organization",
              affinity: ["tax_number"]
          }
      ]
  },
  ".qpon": {
      roles: ["registrant", "tech"]
  },
  ".radio.am": {
      roles: ["registrant", "tech"]
  },
  ".radio.fm": {
      roles: ["registrant", "tech"]
  },
  ".re": {
      roles: ["admin", "registrant", "tech"]
  },
  ".re": {
      roles: ["registrant"],
      affinity: [
          "type"
      ],
      extraValidation: {
          "type": {
              invalidHtml(c) {
                  return translation.get("contact_validated_re_type_required");
              },
              validation(c) {
                  return !![
                      { id: "individual" },
                      { id: "organization" }
                  ].find(i => i.id == (c.extension && c.extension["type"]));
              },
              "extension": true
          },
      },
      "typeOptions": [
           {
               id: "individual",
               text: "Individual",
               affinity: ["id_card_number"]
           },
           {
               id: "organization",
               text: "Organization",
               affinity: ["registration_number","registrant_vat_id"]
           }
      ]
  },
  ".reit": {
      roles: ["registrant", "tech"]
  },
  ".ro": {
      roles: ["registrant"],
      affinity: [
          "type"
      ],
      extraValidation: {
          "type": {
              invalidHtml(c) {
                  return translation.get("contact_validated_se_registrant_type_required");
              },
              validation(c) {
                  return !![
                      { id: "individual" },
                      { id: "organization" }
                  ].find(i => i.id == (c.extension && c.extension["type"]));
              },
              "extension": true
          },
          "registrant_vat_id": {
              invalidHtml(c) {
                  return translation.get("contact_validated_se_vat_required");
              },
              validation(c) {
                  const type = c.extension && c.extension["type"];
                  const v = c.extension && c.extension["registrant_vat_id"];

                  if (type === "organization") {
                      return typeof v === "string" && v.length > 0;
                  }

                  return true; // sometimes
              },
              "extension": true
          },
          "registration_number": {
              invalidHtml(c) {
                  return translation.get("contact_validated_se_registration_number_required");
              },
              validation(c) {
                  const type = c.extension && c.extension["type"];
                  const v = c.extension && c.extension["registration_number"];

                  if (type === "organization") {
                      return typeof v === "string" && v.length > 0;
                  }

                  return true;
              },
              "extension": true
          },
          "id_card_number": {
              invalidHtml(c) {
                  return translation.get("contact_validated_id_card_required");
              },
              validation(c) {
                  const type = c.extension && c.extension["type"];
                  const v = c.extension && c.extension["id_card_number"];

                  if (type === "individual") {
                      return typeof v === "string" && v.length > 0;
                  }

                  return true;
              },
              "extension": true
          }
      },
      "typeOptions": [
           {
               id: "individual",
               text: "Individual",
               affinity: ["id_card_number"]
           },
           {
               id: "organization",
               text: "Organization",
               affinity: ["registration_number","registrant_vat_id"]
           }
      ]
  },
  ".ru.com": {
      roles: ["registrant", "tech"]
  },
  ".ruhr": {
      roles: ["registrant", "tech"]
  },
  ".sa.com": {
      roles: ["registrant", "tech"]
  },
  ".saarland": {
      roles: ["registrant", "tech"]
  },
  ".sc": {
      roles: ["admin", "registrant", "tech"]
  },
  ".scot": {
      roles: ["registrant"],
      dacMessage: translation.get("contact_validated_scot_dacMessage"),
      affinity: ["scot-link"],
      requiredConfirmation: {
          id: "scot-link",
          text: translation.get("contact_validated_scot_basketText"),
          basketText: translation.get("contact_validated_scot_basketText")
      }
  },
  ".se": {
      roles: ["registrant"],
      affinity: [
          "type"
      ],
      extraValidation: {
          "type": {
              invalidHtml(c) {
                  return translation.get("contact_validated_se_registrant_type_required");
              },
              validation(c) {
                  return !![
                      { id: "individual" },
                      { id: "organization" }
                  ].find(i => i.id == (c.extension && c.extension["type"]));
              },
              "extension": true
          },
          "registrant_vat_id": {
              invalidHtml(c) {
                  return translation.get("contact_validated_se_registrant_vat_id_required");
              },
              validation(c) {
                  const type = c.extension && c.extension["type"];
                  const v = c.extension && c.extension["registrant_vat_id"];

                  if (type === "organization") {
                      return typeof v === "string" && v.length > 0;
                  }

                  return true; // sometimes
              },
              "extension": true
          },
          "registration_number": {
              invalidHtml(c) {
                  return translation.get("contact_validated_se_registration_number_required_se");
              },
              validation(c) {
                  const type = c.extension && c.extension["type"];
                  const v = c.extension && c.extension["registration_number"];

                  if (type === "organization") {
                      return typeof v === "string" && v.length > 0;
                  }

                  return true;
              },
              "extension": true
          },
          "id_card_number": {
              invalidHtml(c) {
                  return translation.get("contact_validated_se_id_card_required");
              },
              validation(c) {
                  const type = c.extension && c.extension["type"];
                  const v = c.extension && c.extension["id_card_number"];

                  if (type === "individual") {
                      return typeof v === "string" && v.length > 0;
                  }

                  return true;
              },
              "extension": true
          }
      },
      "typeOptions": [
           {
               id: "individual",
               text: "Individual",
               affinity: ["id_card_number"]
           },
           {
               id: "organization",
               text: "Organization",
               affinity: ["registration_number","registrant_vat_id"]
           }
      ]
  },
  ".sh": {
      roles: ["admin", "registrant", "tech"]
  },
  ".sn": {
      roles: ["admin", "billing", "registrant", "tech"]
  },
  ".srl": {
      roles: ["admin", "registrant", "tech"]
  },
  ".tel.gl": {
      roles: ["registrant", "tech"]
  },
  ".tf": {
      roles: ["admin", "registrant", "tech"]
  },
  ".tv": {
      roles: ["registrant", "tech"]
  },
  ".us": {
      roles: ["registrant"],
      affinity: [
          "type"
      ],
      extraValidation: {
          "type": {
              invalidHtml(c) {
                  return translation.get("contact_validated_us_type_required");
              },
              validation(c) {
                  return !!_DOMAIN_CONTACT_REQUIREMENTS[".us"]['typeOptions'].find(i => i.id == (c.extension && c.extension["type"]));
              },
              "extension": true
          },
          "validator": {
              invalidHtml(c) {
                  return translation.get("contact_validated_us_country_of_citizenship_required");
              },
              validation(c) {
                  if( ["C31","C32"].includes(c['extension']['category']) ){
                      return !!_DOMAIN_CONTACT_REQUIREMENTS[".us"]['extraValidation']['validator'].getOptions(c).find(o => o.id == c.extension["validator"]);
                  } else {
                      return true;
                  }
              },
              getOptions(c) {
                  return _ALL_COUNTRIES;
              },
              "extension": true
          },
          "category": {
              invalidHtml(c) {
                  return translation.get("contact_validated_us_category_required");
              },
              validation(c) {
                  let type = !!_DOMAIN_CONTACT_REQUIREMENTS[".us"].typeOptions.find(o => o.id == c.extension["type"]);
                  let category = !!_DOMAIN_CONTACT_REQUIREMENTS[".us"]['extraValidation']['category'].getOptions(c).find(o => o.id == c.extension["category"]);
                  if( type && category ){
                      return true;
                  } else {
                      return false;
                  }
              },
              getOptions(c) {
                  return [
                      {
                          id: "C11",
                          text: "A citizen of the U.S. or any of its territories."
                      },
                      {
                          id: "C12",
                          text: "permanent resident of the U.S. or any of its territories."
                      },
                      {
                          id: "C21",
                          text: "An organization incorporated within the U.S."
                      },
                      {
                          id: "C31",
                          text: "An entity that regularly engages in lawful activities in the U.S.",
                          affinity: ["validator"]
                      },
                      {
                          id: "C32",
                          text: "An entity that has an office or other facility in the U.S.",
                          affinity: ["validator"]
                      },
                  ];
              },
              "extension": true
          }
      },
      "typeOptions": [
           {
               id: "P1",
               text: "Business use for profit.",
               affinity: ["category"]
           },
           {
               id: "P2",
               text: "Non-profit business, club, association, religious organization, and so on.",
               affinity: ["category"]
           },
           {
               id: "P3",
               text: "Personal use.",
               affinity: ["category"]
           },
           {
               id: "P4",
               text: "Education purposes.",
               affinity: ["category"]
           },
           {
               id: "P5",
               text: "Government purposes.",
               affinity: ["category"]
           }
      ]
  },
  ".versicherung": {
      roles: ["admin", "registrant", "tech"]
  },
  ".vg": {
      roles: ["registrant", "tech"]
  },
  ".wf": {
      roles: ["admin", "registrant", "tech"]
  },
  "xn--4gbrim": {
      roles: ["registrant", "tech"]
  },
  "xn--mgbcpq6gpa1a": {
      roles: ["registrant", "tech"]
  },
  ".yt": {
      roles: ["admin", "registrant", "tech"]
  },
  "za.bz": {
      roles: ["registrant", "tech"]
  },
  "zuerich": {
      roles: ["registrant", "tech"]
  }
}

let NOMINET_TYPES = [
    ".co.uk", ".uk", ".org.uk", ".me.uk", ".net.uk"
];

for(const tld of NOMINET_TYPES){
    _DOMAIN_CONTACT_REQUIREMENTS[tld] = {
        affinity: [
            "type"
        ],
        extraValidation: {
            "trad-name": {
                invalidHtml(c) {
                    return translation.get("contact_validated_uk_trad_name_required");
                },
                validation(c) {
                    const v = c.extension && c.extension["trad-name"];

                    return typeof v === "string" && v.length > 0;
                },
                "extension": true
            },
            "co-no": {
                invalidHtml(c) {
                    return translation.get("contact_validated_uk_co_no_required");
                },
                validation(c) {
                    const v = c.extension && c.extension["co-no"];

                    return typeof v === "string" && v.length > 6;
                },
                "extension": true
            }
        },
        typeOptions: [
            {
                id: "LTD",
                text: "UK Limited Company",
                affinity: ["org", "co-no"]
            },
            {
                id: "PLC",
                text: "UK Public Limited Company",
                affinity: ["org", "co-no"]
            },
            {
                id: "PTNR",
                text: "UK Partnership",
                affinity: ["org"]
            },
            {
                id: "STRA",
                text: "UK Sole Trader",
                affinity: ["org", "trad-name"]
            },
            {
                id: "LLP",
                text: "UK Limited Liability Partnership",
                affinity: ["org", "co-no"]
            },
            {
                id: "IP",
                text: "UK Industrial/Provident Registered Company",
                affinity: ["org", "co-no"]
            },
            {
                id: "IND",
                text: "UK Individual (representing self)",
                affinity: []
            },
            {
                id: "SCH",
                text: "UK School",
                affinity: ["org", "co-no"]
            },
            {
                id: "RCHAR",
                text: "UK Registered Charity",
                affinity: ["org", "trad-name", "co-no"]
            },
            {
                id: "GOV",
                text: "UK Government Body",
                affinity: ["org"]
            },
            {
                id: "CRC",
                text: "UK Corporation by Royal Charter",
                affinity: ["org"]
            },
            {
                id: "STAT",
                text: "UK Statutory Body",
                affinity: ["org"]
            },
            {
                id: "OTHER",
                text: "UK Entity that does not fit into any of the above (e.g. clubs, associations, many universities)",
                affinity: ["org"]
            },
            {
                id: "FIND",
                text: "Non-UK Individual (representing self)",
                affinity: []
            },
            {
                id: "FCORP",
                text: "Non-UK Corporation",
                affinity: ["org"]
            },
            {
                id: "FOTHER",
                text: "Non-UK Entity that does not fit into any of the above (e.g. charities, schools, clubs, associations)",
                affinity: ["org"]
            }
        ]
    }
}

_DOMAIN_CONTACT_REQUIREMENTS[".ltd.uk"] = {
      affinity: [
          "type"
      ],
      extraValidation: {
          "type": {
              invalidHtml(c) {
                  return translation.get("contact_validated_uk_must_be_business");
              },
              validation(c) {
                  return c.extension && c.extension["type"] == "LTD";
              },
              "extension": true
          },
          "trad-name": {
              invalidHtml(c) {
                  return translation.get("contact_validated_uk_trad_name_required");
              },
              validation(c) {
                  const v = c.extension && c.extension["trad-name"];

                  return typeof v === "string" && v.length > 0;
              },
              "extension": true
          },
          "co-no": {
              invalidHtml(c) {
                  return translation.get("contact_validated_uk_co_no_required");
              },
              validation(c) {
                  const v = c.extension && c.extension["co-no"];

                  return typeof v === "string" && v.length > 6;
              },
              "extension": true
          }
    },
    typeOptions: [
        {
            id: "LTD",
            text: "UK Limited Company",
            affinity: ["org", "co-no"]
        }
    ]
};

/**
 * Country-keyed region data for countries with a two-level region→province hierarchy.
 * Mirrors the per-TLD data so the UI can use it regardless of domain type.
 */
const _COUNTRY_REGIONS = {
    "IT": _DOMAIN_CONTACT_REQUIREMENTS[".it"].regions,
    "BR": _DOMAIN_CONTACT_REQUIREMENTS[".com.br"].regions,
    "JP": _DOMAIN_CONTACT_REQUIREMENTS[".jp"].regions,
};

/**
 * Country-keyed province data for countries with a two-level region→province hierarchy.
 */
const _COUNTRY_PROVINCES = {
    "IT": _DOMAIN_CONTACT_REQUIREMENTS[".it"].provinces,
    "BR": _DOMAIN_CONTACT_REQUIREMENTS[".com.br"].provinces,
    "JP": _DOMAIN_CONTACT_REQUIREMENTS[".jp"].provinces,
};

/**
 * Country-keyed flat state/province options for countries with a simple list.
 * Used to show the correct dropdown for any domain type when the contact country matches.
 */
const _COUNTRY_SP_OPTIONS = {
    "US": _US_STATES,
    "CA": _DOMAIN_CONTACT_REQUIREMENTS[".ca"].extraValidation.sp.options(null),
    "AU": _DOMAIN_CONTACT_REQUIREMENTS[".au"].states.map(s => ({id: s.code, text: s.name})),
};

/**
 * Country-keyed postcode validation rules.
 * Each entry has a validation(contact) function and an invalidMessage(contact) function.
 * Applied regardless of domain TLD when no TLD-specific extraValidation.pc is present.
 */
const _COUNTRY_PC_VALIDATION = {
    "US": {
        validation(c) {
            return /^\d{5}(-\d{4}|-\d{6})?$/.test(c.postalInfo.addr.pc || "");
        },
        invalidMessage(c) {
            return "Please enter a valid US ZIP code (e.g. 12345 or 12345-6789).";
        }
    },
    "AU": {
        validation(c) {
            return _DOMAIN_CONTACT_REQUIREMENTS[".au"].extraValidation.pc.validation(c);
        },
        invalidMessage(c) {
            return translation.get("contact_validated_au_pc_invalid");
        }
    },
    "JP": {
        validation(c) {
            return _DOMAIN_CONTACT_REQUIREMENTS[".jp"].extraValidation.pc.validation(c);
        },
        invalidMessage(c) {
            return translation.get("contact_validated_jp_pc_invalid");
        }
    },
    "IT": {
        validation(c) {
            return !!(c.postalInfo.addr.pc || "").match(/^\d{5}$/);
        },
        invalidMessage(c) {
            return translation.get("contact_validated_it_pc_invalid_it");
        }
    },
};
